var PageEntryPoint =
webpackJsonpPageEntryPoint([2,13],{

/***/ "+No7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by c_razmuss_a on 12/10/2017.
 */


var $ = __webpack_require__("7t+N");
__webpack_require__("gNGx");
var positioning = __webpack_require__("KFdh");
var header = __webpack_require__("iPHx");
var footer = __webpack_require__("rqn6");
var internationalSchemeService = __webpack_require__("lQbp");
var loginStatusService = __webpack_require__("Ytzv");
var i18n = __webpack_require__("IlWE");

function init(isLoginLogoutCta) {
    positioning.sameHeightConfig.minWidth = 0;
    positioning.registerSameHeightListener();

    var logonPromise = $.when(i18n.init(), loginStatusService.getIsUserLoggedIn())
        .done(function (i18n, isLoggedIn) {
            var headerCb = (isLoginLogoutCta === true) ? header.initWithLoginCta : header.init;
            headerCb(isLoggedIn, false);
        });

    var contactInfoPromise = internationalSchemeService.getContactInformation();
    contactInfoPromise.done(footer.init);

    return $.when(contactInfoPromise, logonPromise);
}

module.exports.init = init;


/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0v5J":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function formPush(event, formType, formStep, stepType) {
    try {
        var dataLayer = window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event : event,
            formType : formType,
            formStep : formStep,
            stepType : stepType
        });
    } catch (exception) {
        console.log('formSubmissionSuccess dataLayer.push failed');
        return true;
    }
}

function formItemPush(event, formType, formStep, stepType, itemName) {
    try {
        var dataLayer = window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event : event,
            formType : formType,
            formStep : formStep,
            stepType : stepType,
            itemName : itemName
        });
    } catch (exception) {
        console.log('formSubmissionSuccess dataLayer.push failed');
        return true;
    }
}

function formPeoplePush(event, formType, formStep, stepType, peopleCovered) {
    try {
        var dataLayer = window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event : event,
            formType : formType,
            formStep : formStep,
            stepType : stepType,
            peopleCovered : peopleCovered,
        });
    } catch (exception) {
        console.log('formSubmissionSuccess dataLayer.push failed');
        return true;
    }
}

function formPlansPush(event, formType, formStep, stepType, numberPlans) {
    try {
        var dataLayer = window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event : event,
            formType : formType,
            formStep : formStep,
            stepType : stepType,
            numberPlans : numberPlans,
        });
    } catch (exception) {
        console.log('formSubmissionSuccess dataLayer.push failed');
        return true;
    }
}

function quoteCompletePush(event, formType, formStep, peopleCovered, member, stepType) {
    try {
        var dataLayer = window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event : event,
            formType : formType,
            formStep : formStep,
            peopleCovered : peopleCovered,
            member : member,
            stepType : stepType
        });
    } catch (exception) {
        console.log('formSubmissionSuccess dataLayer.push failed');
        return true;
    }
}

function healthPMIQuoteCompletePush(event, formType, formStep, stepType, itemName, peopleCovered) {
    try {
        var dataLayer = window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event : event,
            formType : formType,
            formStep : formStep,
            stepType : stepType,
            itemName : itemName,
            peopleCovered : peopleCovered
        });
    } catch (exception) {
        console.log('formSubmissionSuccess dataLayer.push failed');
        return true;
    }
}

function memberItemPush(event, formType, formStep, stepType, itemName, member) {
    try {
        var dataLayer = window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event : event,
            formType : formType,
            formStep : formStep,
            stepType : stepType,
            itemName : itemName,
            member : member
        });
    } catch (exception) {
        console.log('formSubmissionSuccess dataLayer.push failed');
        return true;
    }
}

function ecommercePush(event, formType, formStep, stepType, peopleCovered, itemCategory, ecommerce) {
    try {
        var dataLayer = window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event : event,
            formType : formType,
            formStep : formStep,
            stepType : stepType,
            peopleCovered : peopleCovered,
            itemCategory : itemCategory,
            ecommerce : ecommerce
        });
    } catch (exception) {
        console.log('formSubmissionSuccess dataLayer.push failed');
        return true;
    }
}

function internationalDestinationPush(event, formType, formStep, stepType, itemName, destination) {
    try {
        var dataLayer = window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event : event,
            formType : formType,
            formStep : formStep,
            stepType : stepType,
            itemName : itemName,
            destination : destination
        });
    } catch (exception) {
        console.log('formSubmissionSuccess dataLayer.push failed');
        return true;
    }
}

function formAddOnsPush(event, formType, formStep, stepType, addOns) {
    try {
        var dataLayer = window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event : event,
            formType : formType,
            formStep : formStep,
            stepType : stepType,
            addOn : addOns
        });
    } catch (exception) {
        console.log('formSubmissionSuccess dataLayer.push failed');
        return true;
    }
}

function intReviewPush(event, formType, formStep, stepType, itemName, addOns, peopleCovered) {
    try {
        var dataLayer = window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event : event,
            formType : formType,
            formStep : formStep,
            stepType : stepType,
            itemName : itemName,
            addOn : addOns,
            peopleCovered : peopleCovered
        });
    } catch (exception) {
        console.log('formSubmissionSuccess dataLayer.push failed');
        return true;
    }
}

module.exports = {
    formPush: formPush,
    formItemPush: formItemPush,
    formPeoplePush : formPeoplePush,
    formPlansPush : formPlansPush,
    quoteCompletePush: quoteCompletePush,
    healthPMIQuoteCompletePush: healthPMIQuoteCompletePush,
    memberItemPush: memberItemPush,
    ecommercePush: ecommercePush,
    internationalDestinationPush: internationalDestinationPush,
    formAddOnsPush: formAddOnsPush,
    intReviewPush: intReviewPush
};

/***/ }),

/***/ "2NfQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * To mimic enum com.vhi.group.web.transactions.TransactionStage from backend
 * Created by c_razmuss_a on 30/01/2018.
 */
//const
var transactionStage = ['INIT', 'POLICY', 'PEOPLE', 'DETAILS', 'COVER', 'ADDONS', 'PLAN', 'CHECKOUT', 'PREFERENCES', 'REVIEW', 'COMPLETED'];

function createStageObject() {
    var result = {};
    transactionStage.forEach(function (stage) {
       result[stage] = stage;
    });
    result.indexOf = function(s, i) {
        return transactionStage.indexOf(s, i);
    };
    return result;
}

module.exports = createStageObject();


/***/ }),

/***/ "7Iys":
/***/ (function(module, exports, __webpack_require__) {

var jade = __webpack_require__("TBTh");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (isLoggedIn) {
var linkId = (isLoggedIn === true) ? 'navbar-logout-link' : 'navbar-login-link'
var linkClass = (isLoggedIn === true) ? 'webchat-myvhi-logout' : 'webchat-myvhi-login'
var btnText = (isLoggedIn === true) ? 'common:header.logout' : 'common:header.login'
var url =  (isLoggedIn === true) ? "javascript:window.location.href='logout';" : '/myvhi'
buf.push("<a" + (jade.attr("id", '' + (linkId) + '', true, true)) + (jade.attr("href", '' + (url) + '', true, true)) + (jade.cls(['navbar-login-link ' + (linkClass) + ''], [true])) + "><button id=\"navbar-login-btn\"" + (jade.attr("data-i18n", "" + (btnText) + "", true, true)) + " class=\"navbar-login-btn\">Log out</button></a>");}.call(this,"isLoggedIn" in locals_for_with?locals_for_with.isLoggedIn:typeof isLoggedIn!=="undefined"?isLoggedIn:undefined));;return buf.join("");
}

/***/ }),

/***/ "7sE5":
/***/ (function(module, exports) {

/**
 * Version: 1.0 Alpha-1 
 * Build Date: 13-Nov-2007
 * Copyright (c) 2006-2007, Coolite Inc. (http://www.coolite.com/). All rights reserved.
 * License: Licensed under The MIT License. See license.txt and http://www.datejs.com/license/. 
 * Website: http://www.datejs.com/ or http://www.coolite.com/datejs/
 */
Date.CultureInfo={name:"en-US",englishName:"English (United States)",nativeName:"English (United States)",dayNames:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],abbreviatedDayNames:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],shortestDayNames:["Su","Mo","Tu","We","Th","Fr","Sa"],firstLetterDayNames:["S","M","T","W","T","F","S"],monthNames:["January","February","March","April","May","June","July","August","September","October","November","December"],abbreviatedMonthNames:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],amDesignator:"AM",pmDesignator:"PM",firstDayOfWeek:0,twoDigitYearMax:2029,dateElementOrder:"mdy",formatPatterns:{shortDate:"M/d/yyyy",longDate:"dddd, MMMM dd, yyyy",shortTime:"h:mm tt",longTime:"h:mm:ss tt",fullDateTime:"dddd, MMMM dd, yyyy h:mm:ss tt",sortableDateTime:"yyyy-MM-ddTHH:mm:ss",universalSortableDateTime:"yyyy-MM-dd HH:mm:ssZ",rfc1123:"ddd, dd MMM yyyy HH:mm:ss GMT",monthDay:"MMMM dd",yearMonth:"MMMM, yyyy"},regexPatterns:{jan:/^jan(uary)?/i,feb:/^feb(ruary)?/i,mar:/^mar(ch)?/i,apr:/^apr(il)?/i,may:/^may/i,jun:/^jun(e)?/i,jul:/^jul(y)?/i,aug:/^aug(ust)?/i,sep:/^sep(t(ember)?)?/i,oct:/^oct(ober)?/i,nov:/^nov(ember)?/i,dec:/^dec(ember)?/i,sun:/^su(n(day)?)?/i,mon:/^mo(n(day)?)?/i,tue:/^tu(e(s(day)?)?)?/i,wed:/^we(d(nesday)?)?/i,thu:/^th(u(r(s(day)?)?)?)?/i,fri:/^fr(i(day)?)?/i,sat:/^sa(t(urday)?)?/i,future:/^next/i,past:/^last|past|prev(ious)?/i,add:/^(\+|after|from)/i,subtract:/^(\-|before|ago)/i,yesterday:/^yesterday/i,today:/^t(oday)?/i,tomorrow:/^tomorrow/i,now:/^n(ow)?/i,millisecond:/^ms|milli(second)?s?/i,second:/^sec(ond)?s?/i,minute:/^min(ute)?s?/i,hour:/^h(ou)?rs?/i,week:/^w(ee)?k/i,month:/^m(o(nth)?s?)?/i,day:/^d(ays?)?/i,year:/^y((ea)?rs?)?/i,shortMeridian:/^(a|p)/i,longMeridian:/^(a\.?m?\.?|p\.?m?\.?)/i,timezone:/^((e(s|d)t|c(s|d)t|m(s|d)t|p(s|d)t)|((gmt)?\s*(\+|\-)\s*\d\d\d\d?)|gmt)/i,ordinalSuffix:/^\s*(st|nd|rd|th)/i,timeContext:/^\s*(\:|a|p)/i},abbreviatedTimeZoneStandard:{GMT:"-000",EST:"-0400",CST:"-0500",MST:"-0600",PST:"-0700"},abbreviatedTimeZoneDST:{GMT:"-000",EDT:"-0500",CDT:"-0600",MDT:"-0700",PDT:"-0800"}};
Date.getMonthNumberFromName=function(name){var n=Date.CultureInfo.monthNames,m=Date.CultureInfo.abbreviatedMonthNames,s=name.toLowerCase();for(var i=0;i<n.length;i++){if(n[i].toLowerCase()==s||m[i].toLowerCase()==s){return i;}}
return-1;};Date.getDayNumberFromName=function(name){var n=Date.CultureInfo.dayNames,m=Date.CultureInfo.abbreviatedDayNames,o=Date.CultureInfo.shortestDayNames,s=name.toLowerCase();for(var i=0;i<n.length;i++){if(n[i].toLowerCase()==s||m[i].toLowerCase()==s){return i;}}
return-1;};Date.isLeapYear=function(year){return(((year%4===0)&&(year%100!==0))||(year%400===0));};Date.getDaysInMonth=function(year,month){return[31,(Date.isLeapYear(year)?29:28),31,30,31,30,31,31,30,31,30,31][month];};Date.getTimezoneOffset=function(s,dst){return(dst||false)?Date.CultureInfo.abbreviatedTimeZoneDST[s.toUpperCase()]:Date.CultureInfo.abbreviatedTimeZoneStandard[s.toUpperCase()];};Date.getTimezoneAbbreviation=function(offset,dst){var n=(dst||false)?Date.CultureInfo.abbreviatedTimeZoneDST:Date.CultureInfo.abbreviatedTimeZoneStandard,p;for(p in n){if(n[p]===offset){return p;}}
return null;};Date.prototype.clone=function(){return new Date(this.getTime());};Date.prototype.compareTo=function(date){if(isNaN(this)){throw new Error(this);}
if(date instanceof Date&&!isNaN(date)){return(this>date)?1:(this<date)?-1:0;}else{throw new TypeError(date);}};Date.prototype.equals=function(date){return(this.compareTo(date)===0);};Date.prototype.between=function(start,end){var t=this.getTime();return t>=start.getTime()&&t<=end.getTime();};Date.prototype.addMilliseconds=function(value){this.setMilliseconds(this.getMilliseconds()+value);return this;};Date.prototype.addSeconds=function(value){return this.addMilliseconds(value*1000);};Date.prototype.addMinutes=function(value){return this.addMilliseconds(value*60000);};Date.prototype.addHours=function(value){return this.addMilliseconds(value*3600000);};Date.prototype.addDays=function(value){return this.addMilliseconds(value*86400000);};Date.prototype.addWeeks=function(value){return this.addMilliseconds(value*604800000);};Date.prototype.addMonths=function(value){var n=this.getDate();this.setDate(1);this.setMonth(this.getMonth()+value);this.setDate(Math.min(n,this.getDaysInMonth()));return this;};Date.prototype.addYears=function(value){return this.addMonths(value*12);};Date.prototype.add=function(config){if(typeof config=="number"){this._orient=config;return this;}
var x=config;if(x.millisecond||x.milliseconds){this.addMilliseconds(x.millisecond||x.milliseconds);}
if(x.second||x.seconds){this.addSeconds(x.second||x.seconds);}
if(x.minute||x.minutes){this.addMinutes(x.minute||x.minutes);}
if(x.hour||x.hours){this.addHours(x.hour||x.hours);}
if(x.month||x.months){this.addMonths(x.month||x.months);}
if(x.year||x.years){this.addYears(x.year||x.years);}
if(x.day||x.days){this.addDays(x.day||x.days);}
return this;};Date._validate=function(value,min,max,name){if(typeof value!="number"){throw new TypeError(value+" is not a Number.");}else if(value<min||value>max){throw new RangeError(value+" is not a valid value for "+name+".");}
return true;};Date.validateMillisecond=function(n){return Date._validate(n,0,999,"milliseconds");};Date.validateSecond=function(n){return Date._validate(n,0,59,"seconds");};Date.validateMinute=function(n){return Date._validate(n,0,59,"minutes");};Date.validateHour=function(n){return Date._validate(n,0,23,"hours");};Date.validateDay=function(n,year,month){return Date._validate(n,1,Date.getDaysInMonth(year,month),"days");};Date.validateMonth=function(n){return Date._validate(n,0,11,"months");};Date.validateYear=function(n){return Date._validate(n,1,9999,"seconds");};Date.prototype.set=function(config){var x=config;if(!x.millisecond&&x.millisecond!==0){x.millisecond=-1;}
if(!x.second&&x.second!==0){x.second=-1;}
if(!x.minute&&x.minute!==0){x.minute=-1;}
if(!x.hour&&x.hour!==0){x.hour=-1;}
if(!x.day&&x.day!==0){x.day=-1;}
if(!x.month&&x.month!==0){x.month=-1;}
if(!x.year&&x.year!==0){x.year=-1;}
if(x.millisecond!=-1&&Date.validateMillisecond(x.millisecond)){this.addMilliseconds(x.millisecond-this.getMilliseconds());}
if(x.second!=-1&&Date.validateSecond(x.second)){this.addSeconds(x.second-this.getSeconds());}
if(x.minute!=-1&&Date.validateMinute(x.minute)){this.addMinutes(x.minute-this.getMinutes());}
if(x.hour!=-1&&Date.validateHour(x.hour)){this.addHours(x.hour-this.getHours());}
if(x.month!==-1&&Date.validateMonth(x.month)){this.addMonths(x.month-this.getMonth());}
if(x.year!=-1&&Date.validateYear(x.year)){this.addYears(x.year-this.getFullYear());}
if(x.day!=-1&&Date.validateDay(x.day,this.getFullYear(),this.getMonth())){this.addDays(x.day-this.getDate());}
if(x.timezone){this.setTimezone(x.timezone);}
if(x.timezoneOffset){this.setTimezoneOffset(x.timezoneOffset);}
return this;};Date.prototype.clearTime=function(){this.setHours(0);this.setMinutes(0);this.setSeconds(0);this.setMilliseconds(0);return this;};Date.prototype.isLeapYear=function(){var y=this.getFullYear();return(((y%4===0)&&(y%100!==0))||(y%400===0));};Date.prototype.isWeekday=function(){return!(this.is().sat()||this.is().sun());};Date.prototype.getDaysInMonth=function(){return Date.getDaysInMonth(this.getFullYear(),this.getMonth());};Date.prototype.moveToFirstDayOfMonth=function(){return this.set({day:1});};Date.prototype.moveToLastDayOfMonth=function(){return this.set({day:this.getDaysInMonth()});};Date.prototype.moveToDayOfWeek=function(day,orient){var diff=(day-this.getDay()+7*(orient||+1))%7;return this.addDays((diff===0)?diff+=7*(orient||+1):diff);};Date.prototype.moveToMonth=function(month,orient){var diff=(month-this.getMonth()+12*(orient||+1))%12;return this.addMonths((diff===0)?diff+=12*(orient||+1):diff);};Date.prototype.getDayOfYear=function(){return Math.floor((this-new Date(this.getFullYear(),0,1))/86400000);};Date.prototype.getWeekOfYear=function(firstDayOfWeek){var y=this.getFullYear(),m=this.getMonth(),d=this.getDate();var dow=firstDayOfWeek||Date.CultureInfo.firstDayOfWeek;var offset=7+1-new Date(y,0,1).getDay();if(offset==8){offset=1;}
var daynum=((Date.UTC(y,m,d,0,0,0)-Date.UTC(y,0,1,0,0,0))/86400000)+1;var w=Math.floor((daynum-offset+7)/7);if(w===dow){y--;var prevOffset=7+1-new Date(y,0,1).getDay();if(prevOffset==2||prevOffset==8){w=53;}else{w=52;}}
return w;};Date.prototype.isDST=function(){console.log('isDST');return this.toString().match(/(E|C|M|P)(S|D)T/)[2]=="D";};Date.prototype.getTimezone=function(){return Date.getTimezoneAbbreviation(this.getUTCOffset,this.isDST());};Date.prototype.setTimezoneOffset=function(s){var here=this.getTimezoneOffset(),there=Number(s)*-6/10;this.addMinutes(there-here);return this;};Date.prototype.setTimezone=function(s){return this.setTimezoneOffset(Date.getTimezoneOffset(s));};Date.prototype.getUTCOffset=function(){var n=this.getTimezoneOffset()*-10/6,r;if(n<0){r=(n-10000).toString();return r[0]+r.substr(2);}else{r=(n+10000).toString();return"+"+r.substr(1);}};Date.prototype.getDayName=function(abbrev){return abbrev?Date.CultureInfo.abbreviatedDayNames[this.getDay()]:Date.CultureInfo.dayNames[this.getDay()];};Date.prototype.getMonthName=function(abbrev){return abbrev?Date.CultureInfo.abbreviatedMonthNames[this.getMonth()]:Date.CultureInfo.monthNames[this.getMonth()];};if (!Date.prototype._toString) {Date.prototype._toString = Date.prototype.toString;}Date.prototype.toString=function(format){var self=this;var p=function p(s){return(s.toString().length==1)?"0"+s:s;};return format?format.replace(/dd?d?d?|MM?M?M?|yy?y?y?|hh?|HH?|mm?|ss?|tt?|zz?z?/g,function(format){switch(format){case"hh":return p(self.getHours()<13?self.getHours():(self.getHours()-12));case"h":return self.getHours()<13?self.getHours():(self.getHours()-12);case"HH":return p(self.getHours());case"H":return self.getHours();case"mm":return p(self.getMinutes());case"m":return self.getMinutes();case"ss":return p(self.getSeconds());case"s":return self.getSeconds();case"yyyy":return self.getFullYear();case"yy":return self.getFullYear().toString().substring(2,4);case"dddd":return self.getDayName();case"ddd":return self.getDayName(true);case"dd":return p(self.getDate());case"d":return self.getDate().toString();case"MMMM":return self.getMonthName();case"MMM":return self.getMonthName(true);case"MM":return p((self.getMonth()+1));case"M":return self.getMonth()+1;case"t":return self.getHours()<12?Date.CultureInfo.amDesignator.substring(0,1):Date.CultureInfo.pmDesignator.substring(0,1);case"tt":return self.getHours()<12?Date.CultureInfo.amDesignator:Date.CultureInfo.pmDesignator;case"zzz":case"zz":case"z":return"";}}):this._toString();};
Date.now=function(){return new Date();};Date.today=function(){return Date.now().clearTime();};Date.prototype._orient=+1;Date.prototype.next=function(){this._orient=+1;return this;};Date.prototype.last=Date.prototype.prev=Date.prototype.previous=function(){this._orient=-1;return this;};Date.prototype._is=false;Date.prototype.is=function(){this._is=true;return this;};Number.prototype._dateElement="day";Number.prototype.fromNow=function(){var c={};c[this._dateElement]=this;return Date.now().add(c);};Number.prototype.ago=function(){var c={};c[this._dateElement]=this*-1;return Date.now().add(c);};(function(){var $D=Date.prototype,$N=Number.prototype;var dx=("sunday monday tuesday wednesday thursday friday saturday").split(/\s/),mx=("january february march april may june july august september october november december").split(/\s/),px=("Millisecond Second Minute Hour Day Week Month Year").split(/\s/),de;var df=function(n){return function(){if(this._is){this._is=false;return this.getDay()==n;}
return this.moveToDayOfWeek(n,this._orient);};};for(var i=0;i<dx.length;i++){$D[dx[i]]=$D[dx[i].substring(0,3)]=df(i);}
var mf=function(n){return function(){if(this._is){this._is=false;return this.getMonth()===n;}
return this.moveToMonth(n,this._orient);};};for(var j=0;j<mx.length;j++){$D[mx[j]]=$D[mx[j].substring(0,3)]=mf(j);}
var ef=function(j){return function(){if(j.substring(j.length-1)!="s"){j+="s";}
return this["add"+j](this._orient);};};var nf=function(n){return function(){this._dateElement=n;return this;};};for(var k=0;k<px.length;k++){de=px[k].toLowerCase();$D[de]=$D[de+"s"]=ef(px[k]);$N[de]=$N[de+"s"]=nf(de);}}());Date.prototype.toJSONString=function(){return this.toString("yyyy-MM-ddThh:mm:ssZ");};Date.prototype.toShortDateString=function(){return this.toString(Date.CultureInfo.formatPatterns.shortDatePattern);};Date.prototype.toLongDateString=function(){return this.toString(Date.CultureInfo.formatPatterns.longDatePattern);};Date.prototype.toShortTimeString=function(){return this.toString(Date.CultureInfo.formatPatterns.shortTimePattern);};Date.prototype.toLongTimeString=function(){return this.toString(Date.CultureInfo.formatPatterns.longTimePattern);};Date.prototype.getOrdinal=function(){switch(this.getDate()){case 1:case 21:case 31:return"st";case 2:case 22:return"nd";case 3:case 23:return"rd";default:return"th";}};
(function(){Date.Parsing={Exception:function(s){this.message="Parse error at '"+s.substring(0,10)+" ...'";}};var $P=Date.Parsing;var _=$P.Operators={rtoken:function(r){return function(s){var mx=s.match(r);if(mx){return([mx[0],s.substring(mx[0].length)]);}else{throw new $P.Exception(s);}};},token:function(s){return function(s){return _.rtoken(new RegExp("^\s*"+s+"\s*"))(s);};},stoken:function(s){return _.rtoken(new RegExp("^"+s));},until:function(p){return function(s){var qx=[],rx=null;while(s.length){try{rx=p.call(this,s);}catch(e){qx.push(rx[0]);s=rx[1];continue;}
break;}
return[qx,s];};},many:function(p){return function(s){var rx=[],r=null;while(s.length){try{r=p.call(this,s);}catch(e){return[rx,s];}
rx.push(r[0]);s=r[1];}
return[rx,s];};},optional:function(p){return function(s){var r=null;try{r=p.call(this,s);}catch(e){return[null,s];}
return[r[0],r[1]];};},not:function(p){return function(s){try{p.call(this,s);}catch(e){return[null,s];}
throw new $P.Exception(s);};},ignore:function(p){return p?function(s){var r=null;r=p.call(this,s);return[null,r[1]];}:null;},product:function(){var px=arguments[0],qx=Array.prototype.slice.call(arguments,1),rx=[];for(var i=0;i<px.length;i++){rx.push(_.each(px[i],qx));}
return rx;},cache:function(rule){var cache={},r=null;return function(s){try{r=cache[s]=(cache[s]||rule.call(this,s));}catch(e){r=cache[s]=e;}
if(r instanceof $P.Exception){throw r;}else{return r;}};},any:function(){var px=arguments;return function(s){var r=null;for(var i=0;i<px.length;i++){if(px[i]==null){continue;}
try{r=(px[i].call(this,s));}catch(e){r=null;}
if(r){return r;}}
throw new $P.Exception(s);};},each:function(){var px=arguments;return function(s){var rx=[],r=null;for(var i=0;i<px.length;i++){if(px[i]==null){continue;}
try{r=(px[i].call(this,s));}catch(e){throw new $P.Exception(s);}
rx.push(r[0]);s=r[1];}
return[rx,s];};},all:function(){var px=arguments,_=_;return _.each(_.optional(px));},sequence:function(px,d,c){d=d||_.rtoken(/^\s*/);c=c||null;if(px.length==1){return px[0];}
return function(s){var r=null,q=null;var rx=[];for(var i=0;i<px.length;i++){try{r=px[i].call(this,s);}catch(e){break;}
rx.push(r[0]);try{q=d.call(this,r[1]);}catch(ex){q=null;break;}
s=q[1];}
if(!r){throw new $P.Exception(s);}
if(q){throw new $P.Exception(q[1]);}
if(c){try{r=c.call(this,r[1]);}catch(ey){throw new $P.Exception(r[1]);}}
return[rx,(r?r[1]:s)];};},between:function(d1,p,d2){d2=d2||d1;var _fn=_.each(_.ignore(d1),p,_.ignore(d2));return function(s){var rx=_fn.call(this,s);return[[rx[0][0],r[0][2]],rx[1]];};},list:function(p,d,c){d=d||_.rtoken(/^\s*/);c=c||null;return(p instanceof Array?_.each(_.product(p.slice(0,-1),_.ignore(d)),p.slice(-1),_.ignore(c)):_.each(_.many(_.each(p,_.ignore(d))),px,_.ignore(c)));},set:function(px,d,c){d=d||_.rtoken(/^\s*/);c=c||null;return function(s){var r=null,p=null,q=null,rx=null,best=[[],s],last=false;for(var i=0;i<px.length;i++){q=null;p=null;r=null;last=(px.length==1);try{r=px[i].call(this,s);}catch(e){continue;}
rx=[[r[0]],r[1]];if(r[1].length>0&&!last){try{q=d.call(this,r[1]);}catch(ex){last=true;}}else{last=true;}
if(!last&&q[1].length===0){last=true;}
if(!last){var qx=[];for(var j=0;j<px.length;j++){if(i!=j){qx.push(px[j]);}}
p=_.set(qx,d).call(this,q[1]);if(p[0].length>0){rx[0]=rx[0].concat(p[0]);rx[1]=p[1];}}
if(rx[1].length<best[1].length){best=rx;}
if(best[1].length===0){break;}}
if(best[0].length===0){return best;}
if(c){try{q=c.call(this,best[1]);}catch(ey){throw new $P.Exception(best[1]);}
best[1]=q[1];}
return best;};},forward:function(gr,fname){return function(s){return gr[fname].call(this,s);};},replace:function(rule,repl){return function(s){var r=rule.call(this,s);return[repl,r[1]];};},process:function(rule,fn){return function(s){var r=rule.call(this,s);return[fn.call(this,r[0]),r[1]];};},min:function(min,rule){return function(s){var rx=rule.call(this,s);if(rx[0].length<min){throw new $P.Exception(s);}
return rx;};}};var _generator=function(op){return function(){var args=null,rx=[];if(arguments.length>1){args=Array.prototype.slice.call(arguments);}else if(arguments[0]instanceof Array){args=arguments[0];}
if(args){for(var i=0,px=args.shift();i<px.length;i++){args.unshift(px[i]);rx.push(op.apply(null,args));args.shift();return rx;}}else{return op.apply(null,arguments);}};};var gx="optional not ignore cache".split(/\s/);for(var i=0;i<gx.length;i++){_[gx[i]]=_generator(_[gx[i]]);}
var _vector=function(op){return function(){if(arguments[0]instanceof Array){return op.apply(null,arguments[0]);}else{return op.apply(null,arguments);}};};var vx="each any all".split(/\s/);for(var j=0;j<vx.length;j++){_[vx[j]]=_vector(_[vx[j]]);}}());(function(){var flattenAndCompact=function(ax){var rx=[];for(var i=0;i<ax.length;i++){if(ax[i]instanceof Array){rx=rx.concat(flattenAndCompact(ax[i]));}else{if(ax[i]){rx.push(ax[i]);}}}
return rx;};Date.Grammar={};Date.Translator={hour:function(s){return function(){this.hour=Number(s);};},minute:function(s){return function(){this.minute=Number(s);};},second:function(s){return function(){this.second=Number(s);};},meridian:function(s){return function(){this.meridian=s.slice(0,1).toLowerCase();};},timezone:function(s){return function(){var n=s.replace(/[^\d\+\-]/g,"");if(n.length){this.timezoneOffset=Number(n);}else{this.timezone=s.toLowerCase();}};},day:function(x){var s=x[0];return function(){this.day=Number(s.match(/\d+/)[0]);};},month:function(s){return function(){this.month=((s.length==3)?Date.getMonthNumberFromName(s):(Number(s)-1));};},year:function(s){return function(){var n=Number(s);this.year=((s.length>2)?n:(n+(((n+2000)<Date.CultureInfo.twoDigitYearMax)?2000:1900)));};},rday:function(s){return function(){switch(s){case"yesterday":this.days=-1;break;case"tomorrow":this.days=1;break;case"today":this.days=0;break;case"now":this.days=0;this.now=true;break;}};},finishExact:function(x){x=(x instanceof Array)?x:[x];var now=new Date();this.year=now.getFullYear();this.month=now.getMonth();this.day=1;this.hour=0;this.minute=0;this.second=0;for(var i=0;i<x.length;i++){if(x[i]){x[i].call(this);}}
this.hour=(this.meridian=="p"&&this.hour<13)?this.hour+12:this.hour;if(this.day>Date.getDaysInMonth(this.year,this.month)){throw new RangeError(this.day+" is not a valid value for days.");}
var r=new Date(this.year,this.month,this.day,this.hour,this.minute,this.second);if(this.timezone){r.set({timezone:this.timezone});}else if(this.timezoneOffset){r.set({timezoneOffset:this.timezoneOffset});}
return r;},finish:function(x){x=(x instanceof Array)?flattenAndCompact(x):[x];if(x.length===0){return null;}
for(var i=0;i<x.length;i++){if(typeof x[i]=="function"){x[i].call(this);}}
if(this.now){return new Date();}
var today=Date.today();var method=null;var expression=!!(this.days!=null||this.orient||this.operator);if(expression){var gap,mod,orient;orient=((this.orient=="past"||this.operator=="subtract")?-1:1);if(this.weekday){this.unit="day";gap=(Date.getDayNumberFromName(this.weekday)-today.getDay());mod=7;this.days=gap?((gap+(orient*mod))%mod):(orient*mod);}
if(this.month){this.unit="month";gap=(this.month-today.getMonth());mod=12;this.months=gap?((gap+(orient*mod))%mod):(orient*mod);this.month=null;}
if(!this.unit){this.unit="day";}
if(this[this.unit+"s"]==null||this.operator!=null){if(!this.value){this.value=1;}
if(this.unit=="week"){this.unit="day";this.value=this.value*7;}
this[this.unit+"s"]=this.value*orient;}
return today.add(this);}else{if(this.meridian&&this.hour){this.hour=(this.hour<13&&this.meridian=="p")?this.hour+12:this.hour;}
if(this.weekday&&!this.day){this.day=(today.addDays((Date.getDayNumberFromName(this.weekday)-today.getDay()))).getDate();}
if(this.month&&!this.day){this.day=1;}
return today.set(this);}}};var _=Date.Parsing.Operators,g=Date.Grammar,t=Date.Translator,_fn;g.datePartDelimiter=_.rtoken(/^([\s\-\.\,\/\x27]+)/);g.timePartDelimiter=_.stoken(":");g.whiteSpace=_.rtoken(/^\s*/);g.generalDelimiter=_.rtoken(/^(([\s\,]|at|on)+)/);var _C={};g.ctoken=function(keys){var fn=_C[keys];if(!fn){var c=Date.CultureInfo.regexPatterns;var kx=keys.split(/\s+/),px=[];for(var i=0;i<kx.length;i++){px.push(_.replace(_.rtoken(c[kx[i]]),kx[i]));}
fn=_C[keys]=_.any.apply(null,px);}
return fn;};g.ctoken2=function(key){return _.rtoken(Date.CultureInfo.regexPatterns[key]);};g.h=_.cache(_.process(_.rtoken(/^(0[0-9]|1[0-2]|[1-9])/),t.hour));g.hh=_.cache(_.process(_.rtoken(/^(0[0-9]|1[0-2])/),t.hour));g.H=_.cache(_.process(_.rtoken(/^([0-1][0-9]|2[0-3]|[0-9])/),t.hour));g.HH=_.cache(_.process(_.rtoken(/^([0-1][0-9]|2[0-3])/),t.hour));g.m=_.cache(_.process(_.rtoken(/^([0-5][0-9]|[0-9])/),t.minute));g.mm=_.cache(_.process(_.rtoken(/^[0-5][0-9]/),t.minute));g.s=_.cache(_.process(_.rtoken(/^([0-5][0-9]|[0-9])/),t.second));g.ss=_.cache(_.process(_.rtoken(/^[0-5][0-9]/),t.second));g.hms=_.cache(_.sequence([g.H,g.mm,g.ss],g.timePartDelimiter));g.t=_.cache(_.process(g.ctoken2("shortMeridian"),t.meridian));g.tt=_.cache(_.process(g.ctoken2("longMeridian"),t.meridian));g.z=_.cache(_.process(_.rtoken(/^(\+|\-)?\s*\d\d\d\d?/),t.timezone));g.zz=_.cache(_.process(_.rtoken(/^(\+|\-)\s*\d\d\d\d/),t.timezone));g.zzz=_.cache(_.process(g.ctoken2("timezone"),t.timezone));g.timeSuffix=_.each(_.ignore(g.whiteSpace),_.set([g.tt,g.zzz]));g.time=_.each(_.optional(_.ignore(_.stoken("T"))),g.hms,g.timeSuffix);g.d=_.cache(_.process(_.each(_.rtoken(/^([0-2]\d|3[0-1]|\d)/),_.optional(g.ctoken2("ordinalSuffix"))),t.day));g.dd=_.cache(_.process(_.each(_.rtoken(/^([0-2]\d|3[0-1])/),_.optional(g.ctoken2("ordinalSuffix"))),t.day));g.ddd=g.dddd=_.cache(_.process(g.ctoken("sun mon tue wed thu fri sat"),function(s){return function(){this.weekday=s;};}));g.M=_.cache(_.process(_.rtoken(/^(1[0-2]|0\d|\d)/),t.month));g.MM=_.cache(_.process(_.rtoken(/^(1[0-2]|0\d)/),t.month));g.MMM=g.MMMM=_.cache(_.process(g.ctoken("jan feb mar apr may jun jul aug sep oct nov dec"),t.month));g.y=_.cache(_.process(_.rtoken(/^(\d\d?)/),t.year));g.yy=_.cache(_.process(_.rtoken(/^(\d\d)/),t.year));g.yyy=_.cache(_.process(_.rtoken(/^(\d\d?\d?\d?)/),t.year));g.yyyy=_.cache(_.process(_.rtoken(/^(\d\d\d\d)/),t.year));_fn=function(){return _.each(_.any.apply(null,arguments),_.not(g.ctoken2("timeContext")));};g.day=_fn(g.d,g.dd);g.month=_fn(g.M,g.MMM);g.year=_fn(g.yyyy,g.yy);g.orientation=_.process(g.ctoken("past future"),function(s){return function(){this.orient=s;};});g.operator=_.process(g.ctoken("add subtract"),function(s){return function(){this.operator=s;};});g.rday=_.process(g.ctoken("yesterday tomorrow today now"),t.rday);g.unit=_.process(g.ctoken("minute hour day week month year"),function(s){return function(){this.unit=s;};});g.value=_.process(_.rtoken(/^\d\d?(st|nd|rd|th)?/),function(s){return function(){this.value=s.replace(/\D/g,"");};});g.expression=_.set([g.rday,g.operator,g.value,g.unit,g.orientation,g.ddd,g.MMM]);_fn=function(){return _.set(arguments,g.datePartDelimiter);};g.mdy=_fn(g.ddd,g.month,g.day,g.year);g.ymd=_fn(g.ddd,g.year,g.month,g.day);g.dmy=_fn(g.ddd,g.day,g.month,g.year);g.date=function(s){return((g[Date.CultureInfo.dateElementOrder]||g.mdy).call(this,s));};g.format=_.process(_.many(_.any(_.process(_.rtoken(/^(dd?d?d?|MM?M?M?|yy?y?y?|hh?|HH?|mm?|ss?|tt?|zz?z?)/),function(fmt){if(g[fmt]){return g[fmt];}else{throw Date.Parsing.Exception(fmt);}}),_.process(_.rtoken(/^[^dMyhHmstz]+/),function(s){return _.ignore(_.stoken(s));}))),function(rules){return _.process(_.each.apply(null,rules),t.finishExact);});var _F={};var _get=function(f){return _F[f]=(_F[f]||g.format(f)[0]);};g.formats=function(fx){if(fx instanceof Array){var rx=[];for(var i=0;i<fx.length;i++){rx.push(_get(fx[i]));}
return _.any.apply(null,rx);}else{return _get(fx);}};g._formats=g.formats(["yyyy-MM-ddTHH:mm:ss","ddd, MMM dd, yyyy H:mm:ss tt","ddd MMM d yyyy HH:mm:ss zzz","d"]);g._start=_.process(_.set([g.date,g.time,g.expression],g.generalDelimiter,g.whiteSpace),t.finish);g.start=function(s){try{var r=g._formats.call({},s);if(r[1].length===0){return r;}}catch(e){}
return g._start.call({},s);};}());Date._parse=Date.parse;Date.parse=function(s){var r=null;if(!s){return null;}
try{r=Date.Grammar.start.call({},s);}catch(e){return null;}
return((r[1].length===0)?r[0]:null);};Date.getParseFunction=function(fx){var fn=Date.Grammar.formats(fx);return function(s){var r=null;try{r=fn.call({},s);}catch(e){return null;}
return((r[1].length===0)?r[0]:null);};};Date.parseExact=function(s,fx){return Date.getParseFunction(fx)(s);};


/***/ }),

/***/ "ABcN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Service for retrieving Employee groups from server
 * handles standard server side errors
 *
 * Created by c_razmuss_a on 22/01/2018.
 */

var $ = __webpack_require__("7t+N");
var ajaxHandler = __webpack_require__("CCE4");

/**
 * GET employee Groups for scheme currently available in session
 * returns object with at least one key,value pair
 */
function getEmployeeGroups() {
    return ajaxHandler.ajaxGetJson({ url: "/intgroups" + '/rest/employeeGroups' })
        .then(function(data, textStatus, jqXHR) {
            if (data.employeeGroups && Object.keys(data.employeeGroups).length > 0) {
                return data.employeeGroups;
            }
            else {
                console.error("Employee groups didn't return expected format " + data.employeeGroup);
                return $.Deferred().reject({}).promise();
            }
        })
        .fail(ajaxHandler.handleError('Could not retrieve employee groups list'));
}

function getCategoryStaffDetails(categoryId) {
    return ajaxHandler.ajaxGetJson({url: "/intgroups" + '/rest/category/' + categoryId})
        .then(populateCategoryStaffDetails)
        .fail(ajaxHandler.handleError("Couldn't receive Category cost center or staff id data"));
}

function getCategoryStaffDetailsByPolicyNumber(policyNumber) {
    return ajaxHandler.ajaxGetJson({url: "/intgroups" + '/rest/category/policy/' + policyNumber})
        .then(populateCategoryStaffDetails)
        .fail(ajaxHandler.handleError("Couldn't receive Category cost center or staff id data"));
}

function populateCategoryStaffDetails(categoryDetailsResponse) {
    var result = {};
    if (categoryDetailsResponse.costCentreDetails && categoryDetailsResponse.costCentreDetails.isCostCentreMandatory) {
        result.costCenter = {};
        result.costCenter.label = categoryDetailsResponse.costCentreDetails.costCentreName;
        result.costCenter.support = categoryDetailsResponse.costCentreDetails.costCentreSupportText;
    }

    if (categoryDetailsResponse.staffIdDetails && categoryDetailsResponse.staffIdDetails.isStaffIdMandatory) {
        result.staffId = {};
        result.staffId.label = categoryDetailsResponse.staffIdDetails.staffIdName;
        result.staffId.support = categoryDetailsResponse.staffIdDetails.staffIdSupportText;
    }
    return result;
}

module.exports.getEmployeeGroups = getEmployeeGroups;
module.exports.getCategoryStaffDetails = getCategoryStaffDetails;
module.exports.getCategoryStaffDetailsByPolicyNumber = getCategoryStaffDetailsByPolicyNumber;

/***/ }),

/***/ "B67l":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var dateUtils = __webpack_require__("lglL");

function dateToUserFormat(argDate) {
    if (argDate) {
        return dateUtils.format2user(argDate);
    } else {
        return argDate;
    }
}

function dateToServerFormat(argDate) {
    if (argDate) {
        return dateUtils.format2server(argDate);
    } else {
        return argDate;
    }
}

function booleanToFrontEnd(boolean) {
    if (boolean !== null) {
        return (boolean) ? 'YES' : 'NO';
    } else {
        return boolean;
    }
}

function frontEndToBoolean(yesNo) {
    if (yesNo !== null) {
        return (yesNo === 'YES');
    }
}

module.exports.dateToUserFormat = dateToUserFormat;
module.exports.dateToServerFormat = dateToServerFormat;
module.exports.booleanToFrontEnd = booleanToFrontEnd;
module.exports.frontEndToBoolean = frontEndToBoolean;

/***/ }),

/***/ "CCE4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("7t+N");
var urls = __webpack_require__("g+w9");

var ajaxStatusConfig = {
    STATUS_GONE: 410,
    UNPROCESSABLE: 422,
	NOT_IMPLEMENTED: 501
};

function ajaxGetJson(config){
	return $.ajax({
					url : config.url,
					dataType: 'json',
					contentType: 'application/json; charset=utf-8',
					headers: config.headers,
					data: getJsonString(config),
					async	: getAsync(config),
					type : 'GET'
			});
}

function ajaxPostJson(config) {
	return $.ajax({
		url : config.url,
		dataType: 'json',
		contentType: 'application/json; charset=utf-8',
		headers: getHeaders(config),
		data: getJsonString(config),
		async	: getAsync(config),
		type : 'POST',
		timeout: config.timeout
	});
}

function getJsonString(config){
	return (typeof config.jsonString !== 'undefined') ? config.jsonString : '';
}

function getAsync(config) {
	if (typeof config.async === 'undefined') {
		return true;
	} else {
		return config.async;
	}
}

function getHeaders(config){
	return (typeof config.headers !== 'undefined') ? config.headers : '';
}

/**
 * Helper method to be used in .fail() handler of jquery AJAX requests
 * Provides generic failure handling and ability to ignore certain codes
 * @param message
 * @param ignoreCodes - optional array of numbers for status codes for which error handling won't be invoked
 * @returns {Function}
 */
function handleError(message, ignoreCodes) {
    return function (jqXHR, status, faf) {
        if (ignoreCodes && ignoreCodes.indexOf(jqXHR.status) > -1) {
            console.log('Skipping processing of error code ' + jqXHR.status);
        } else {
            errorHandler(jqXHR, message);
        }
    };
}

/**
 * Jquery ajax error handler
 */
function errorHandler(jqXHR, message) {
    console.error('ajaxHandler.errorHandler '+jqXHR.status+' '+ message);
    if (jqXHR.status === ajaxStatusConfig.UNPROCESSABLE) {
        return;
    }

    if (jqXHR.status === ajaxStatusConfig.STATUS_GONE) {
        urls.navigateToUrl("/intgroups"+'/session-expired');
        return;
    }

    if (jqXHR.status === ajaxStatusConfig.NOT_IMPLEMENTED) {
        urls.navigateToUrl("/intgroups"+'/not-supported');
        return;
    }
	urls.navigateToUrl("/intgroups"+'/internal-problem');

}

module.exports = {
	ajaxGetJson : ajaxGetJson,
	ajaxPostJson: ajaxPostJson,
    handleError: handleError,
	errorHandler: errorHandler,
};



/***/ }),

/***/ "Dh8f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__("7t+N");
var urls = __webpack_require__("g+w9");
var transactionStage = __webpack_require__("2NfQ");

function renderSecondaryBreadCrumbs() {
    var $breadcrumbSecondary_element = $('.breadcrumb-secondary .element');
    if($breadcrumbSecondary_element.length === 2) {
        $('.breadcrumb-secondary').css('width', '212px');
    }

    var hasCurrent = $('.breadcrumb-secondary .element.current').length > 0;
    var prev = null;
    $breadcrumbSecondary_element.each(function(){
        if(prev !== null) {
            var currentPos = $(this).offset().left + $(this).width()/2;
            var prevPos = prev.offset().left + prev.width()/2;
            var width = currentPos - prevPos;
            $(this).find('.line').css({'width': width, 'right': $(this).width()/2});
        }
        prev = $(this);

        if(hasCurrent) {
            $(this).addClass('active');
        }

        if($(this).hasClass('current')) {
            hasCurrent = false;
        }
    });
}

function init(props) {
    renderSecondaryBreadCrumbs();
    $(window).resize(function(){
        renderSecondaryBreadCrumbs();
    });
    initOnDataChange();

    setAccessibleByTransactionStage(props.sessionTransactionStage);

}

function setAccessibleByTransactionStage(stage) {

    var index = transactionStage.indexOf(stage);

    function render(element) {
        var elementId = element.attr('data-id');
        var elementIndex = transactionStage.indexOf(elementId);
        
        if(elementIndex > index) {
            return false;
        }

        element.addClass('navi');            
        if(stage === elementId) {
            return false;
        }

        return true;
    }

    // Set accessible primary breadcrumb
    $('.breadcrumb-primary .element').each(function(){
        if(!render($(this))) { 
            return false;
        }
    });
    // Set accessible secondary breadcrumb
    $('.breadcrumb-secondary .element').each(function(){
        if(!render($(this))) { 
            return false;
        }
    });
}

$('.breadcrumb-primary .element a, .breadcrumb-secondary .element a').click(function(e){
    e.preventDefault();
    //Prevent users to be able to navigate to link if not allowed
    var parent = $(this).parent('.element');
    if((!parent.hasClass('active') && !parent.hasClass('navi')) || parent.hasClass('current')) {
        return false;
    }

    //Append parameters if present
    var href = $(this).attr('href');

    if(urls.getAllUrlParameters()) {
        if(href.indexOf('?') !== -1) {
            href += '&';
        } else {
            href += '?';
        }
        href += urls.getAllUrlParameters();
    }
    urls.navigateToUrl(href);
    
});

function initOnDataChange() {
    $('.journey-container')
        .on('input', 'input', clearForwardLinks)
        .on('change', 'select', clearForwardLinks)
        .on('click', 'input[type="radio"]', clearForwardLinks)
        .on('click', 'input[type="checkbox"]', clearForwardLinks)
        .on('change', '.datepicker', clearForwardLinks);

    $('body').on('click', '.carousel .add-people-checkbox', clearForwardLinks);
}

function clearForwardLinks() {

    //attribute will be used to indicate that user has made a data change on the form.
    //Will be used to decide whether to POST or forward to next page in scenario
    //where they have navigated backwards in the journey
    $('.journey-container').attr('data-changed', true);

    var primaryNav = true;
    $('.breadcrumb-primary .element').each(function(){
        if(primaryNav && $(this).hasClass('current')) {
            primaryNav = false;
        } else if(!primaryNav) {
            $(this).removeClass('navi');
        }
    });

    var secondaryNav = true;
    $('.breadcrumb-secondary .element').each(function(){
        if(secondaryNav && $(this).hasClass('current')) {
            secondaryNav = false;
        } else if(!secondaryNav) {
            $(this).removeClass('navi');
        }
    });
}

module.exports = {
    init: init,
    clearForwardLinks: clearForwardLinks,
    setAccessibleByTransactionStage: setAccessibleByTransactionStage,
};


/***/ }),

/***/ "IlWE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var i18n = __webpack_require__("lwx0");

var options = {
    ns: ['intl', 'common'],
    defaultNS: 'intl',
    backend: {
        loadPath: "/intgroups" + '/locales/{{lng}}/{{ns}}.json'
    },
};

var initialized;

function init() {
    if (initialized === undefined) {
        initialized = i18n.doSetup(options);
    }
    return initialized;
}

module.exports = {
    init: init,
    translate: i18n.translate
};


/***/ }),

/***/ "JOWb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = __webpack_require__("Eb2/").namespace('groups');


/***/ }),

/***/ "KVib":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var store = __webpack_require__("juAn");

var cacheKey = 'intlSessionTransactionStage';

function setTransactionStage(transactionStage) {
    store.session(cacheKey, transactionStage);
}

function getTransactionStage() {
    if (store.session.has(cacheKey)) {
        return store.session.get(cacheKey);
    }
    else {
        return 'INIT';
    }
}

module.exports = {
    setTransactionStage : setTransactionStage,
    getTransactionStage: getTransactionStage
};

/***/ }),

/***/ "LaRm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * This function can only be used if bootstrap has been initialized on the page
 */
var $ = __webpack_require__("7t+N");
var groupSchemeService = __webpack_require__("pHlT");
var dateUtils = __webpack_require__("lglL");
var popover = __webpack_require__("z0NW");
__webpack_require__("t+Rb");


function registerYesToggle(context) {
    $('[data-yes-show-input]', context).change(function(e) {
        var trigger = $(e.target);
        var idToShow = trigger.attr('data-yes-show-input');
        var $inputElement = $("#"+idToShow).val('');
        resetSelectPicker($inputElement);
        $inputElement.closest('.form-group').toggleClass('hidden', trigger.val() !== 'YES');
    });
}

function registerNoToggle(context) {
    $('[data-no-show-input]', context).change(function(e) {
        var trigger = $(e.target);
        var idToShow = trigger.attr('data-no-show-input');
        var $inputElement = $("#"+idToShow).val('');
        resetSelectPicker($inputElement);
        $inputElement.closest('.form-group').toggleClass('hidden', trigger.val() !== 'NO');
    });
}

function resetSelectPicker($element) {
    if ($element.is(".selectpicker")) {
        $element.selectpicker('val','');
    }
}

function applyMasks(context) {
    $('input.date-mask', context).mask('00/00/0000');
    $('.capital-mask', context).on('blur', function () {$(this).val($(this).val().charAt(0).toUpperCase() + $(this).val().slice(1) );});
}

/**
 * Gets the value of the changesEffectiveFromRenewalDate field from the Group Scheme Service
 * The value's context is the Group Scheme. It is set as a checkbox in GIOS and it indicates that the user will now be
 * given the option of selecting the Group's next renewal date as their policy start date
 * @param model
 * @param checkboxElement - form input checkbox element for the changesEffectiveFromRenewalDate field selection
 * @param checkboxMainContainerElement - the entire checkbox input row and text info relating to it
 */
function renderChangesEffectiveFromRenewalDateCheckboxElement(model, checkboxElement, checkboxMainContainerElement) {
    // set default value
    model.groupSchemeBasicInfoData = {changesEffectiveFromRenewalDate: false };
    //  get the changesEffectiveFromRenewalDate value from the session
    var groupSchemeBasicInfoPromise = groupSchemeService.getGroupScheme(true);
    $.when(groupSchemeBasicInfoPromise)
        .done(function(groupSchemeBasicInfoData) {
            model.renewalDate = groupSchemeBasicInfoData.renewalDate;
            model.groupSchemeBasicInfoData.changesEffectiveFromRenewalDate =
                groupSchemeBasicInfoData.changesEffectiveFromRenewalDate;

            // set checkbox ui elements
            popover.initPopOver();
            // checkbox may have been previously displayed and checked, so uncheck
            checkboxElement.prop('checked', false);

            if(model.groupSchemeBasicInfoData.changesEffectiveFromRenewalDate) {
                checkboxMainContainerElement.removeClass('hidden');
                $('#policyStartDateRow').addClass('shorten-height-minus-margin');
            } else {
                checkboxMainContainerElement.addClass('hidden');
                $('#policyStartDateRow').removeClass('shorten-height-minus-margin');
            }
        });
}

/**
 * Sets the click event listener for the checkbox
 * @param checkboxElement - form input checkbox element for the changesEffectiveFromRenewalDate field selection
 * @param startDatePicker
 * @param model
 * @param policyStartDateElement - startDate text input element
 * @param callback - resets Product Type and resets the startDatePicker dropdown
 */
function changesEffectiveFromRenewalDateSetClickEvent(checkboxElement, startDatePicker, model, policyStartDateElement,
                                                   callback) {
    checkboxElement.on('change', function(){
        var selected = checkboxElement.is(':checked');
        checkboxElement.prop('checked', selected);
        model.policyInfo.basicPolicyInfo.changesEffectiveFromRenewalDate = selected;

        if(selected) {
            startDatePicker.renderSingleDate(model.renewalDate);
            var date = new Date(model.renewalDate);
            var formattedDate = dateUtils.dateFormatDayMonthYear(date);
            var datePickerFormatted = $(policyStartDateElement).datepicker({ format: 'dd/mm/yyyy' });
            datePickerFormatted.datepicker('setDate', formattedDate);
            $(policyStartDateElement).prop('disabled', true);
            checkboxElement.val(true);
        } else {
            // reset datepicker back to correct range for selected product
            if(callback) { callback(); }
            $(policyStartDateElement).prop('disabled', false);
            checkboxElement.val(false);
        }
    });
}

function trimElementValue(elementId) {
    $(elementId).val($(elementId).val().trim());
}

function trimInput(elementId) {
    if($('[id^='+elementId+']').length) {
        $('[id^='+elementId+']').each(function(){
            trimElementValue($(this));
        });
    }
}


module.exports.registerYesToggle = registerYesToggle;
module.exports.registerNoToggle = registerNoToggle;
module.exports.applyMasks = applyMasks;

module.exports.renderChangesEffectiveFromRenewalDateCheckboxElement = renderChangesEffectiveFromRenewalDateCheckboxElement;
module.exports.changesEffectiveFromRenewalDateSetClickEvent = changesEffectiveFromRenewalDateSetClickEvent;
module.exports.trimElementValue = trimElementValue;
module.exports.trimInput = trimInput;


/***/ }),

/***/ "NI/0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__("7t+N");
var urls = __webpack_require__("g+w9");
var ajaxHandler = __webpack_require__("CCE4");
var converter = __webpack_require__("B67l");

function getTransactionState() {
    var transactionId = urls.getUrlParameter("transaction-id");
    if (typeof transactionId === "undefined") {
        console.error("transaction-id not defined. Can't load transaction data");
        return ajaxHandler.ajaxPostJson({ url: "/intgroups" + '/rest/transactions' })
            .then(function(res) {
                urls.redirectToUrl(window.location.href + '?transaction-id=' + res.transactionId);
                return $.Deferred().reject();
            });
    } else {
        return ajaxHandler.ajaxGetJson({ url: "/intgroups" + '/rest/transactions/' + transactionId + '/details' })
            .then(function(res) {
                res.transactionId = transactionId;
                return convertToModel(res);
            })
            .fail(ajaxHandler.handleError('unable to get case details'));
    }
}

function postTransactionState(model) {
    var data = convertToBackend(model);
    var request = { url: "/intgroups" + '/rest/transactions/' + model.transactionId + '/details', jsonString: JSON.stringify(data) };
    return ajaxHandler.ajaxPostJson(request)
        .fail(ajaxHandler.handleError('unable to postTransactionState : ' + request.jsonString));
}

function convertToModel(data) {
    if (typeof data === 'undefined') {
        return {};
    }
    var result = $.extend({}, data);
    result.policyDate = converter.dateToUserFormat(result.policyDate);

    return result;
}

function convertToBackend(model) {
    var result = $.extend({}, model);
    delete result.transactionId;
    result.policyDate = converter.dateToServerFormat(result.policyDate);
    return result;
}

module.exports = {
    getTransactionState: getTransactionState,
    postTransactionState: postTransactionState
};


/***/ }),

/***/ "OEM9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("7t+N");
__webpack_require__("tNVI");
var employeeGroupsService = __webpack_require__("ABcN");
var assertExists = __webpack_require__("VgQt").assertExists;

/**
 * Initialized the EmployeeGroupSelection component which first does fetch from backend to determine available groups for current session
 *
 * config = {id: 'string', mountOn: 'string', onGroupChange: callback, renderSingleGroup: false, readOnly: false}
 *
 * @param config - where,
 *   id  (String) - id for the component to render
 *   mountOn (String) - id for the element on page which component must be mounted on
 *   onGroupChange (function, optional) - callback function where only argument is the new value selected
 *   renderSingleGroup (Boolean, optional, default=false) - by default if only one employee group exists this component is not rendered. set to true to render
 *   readOnly (Boolean, optional, default=false) - render as read only field
 *
 *  Returns - Promise which is resolved with this components available methods:
 *   setValue(employeeGroupId)
 *   getAvailableGroups() - returns array of employee group ids available for current component
 *
 * Created by c_razmuss_a on 19/01/2018.
 *
 */
module.exports = function EmployeeGroupSelector(config) {
    assertExists(config.id, "Missing property id - mandatory value");
    assertExists(config.mountOn, "Missing  property mountOn - where this component should be rendered?");

    var employeeGroups;

    return employeeGroupsService.getEmployeeGroups()
        .then(function(result) {
            employeeGroups = result;
            if (config.renderSingleGroup || Object.keys(employeeGroups).length > 1) {
                render();
            }
            return {
                getId: function() {
                    return config.id;
                },
                setValue: setValue,
                getAvailableGroups: function () {
                    return Object.keys(employeeGroups);
                }
            };
    });

    function render() {
        var props = {
            id: config.id,
            mountOn: config.mountOn,
            employeeGroups: employeeGroups,
            readOnly: config.readOnly,
            inputName: config.inputName,
            i18nContext: config.i18nContext
        };
        var html = __webpack_require__("fJHJ")(props);
        $('#'+config.mountOn).replaceWith(html);
        $('#' + config.id).selectpicker();
        if (config.onChange) {
            $('#' + config.id).change(function (event) {
                config.onChange(event.target.value);
            });
        }
    }

    function setValue(value) {
        $('#'+config.id).val(value).selectpicker('render');
    }

};


/***/ }),

/***/ "P32B":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("7t+N");
__webpack_require__("71lI");
var startDatesService = __webpack_require__("iyeL");
var errorByKey = __webpack_require__("kMMZ").errorByKey;
var assertExists = __webpack_require__("VgQt").assertExists;
var dateUtils = __webpack_require__("lglL");

module.exports = function StartDatePicker(config) {
    assertExists(config.id, "Missing property id - mandatory value");
    assertExists(config.mountOn, "Missing  property mountOn - where this component should be rendered?");

    if (config.mountImmediateley) {
        doRender();
    }
    registerValidationMethods();

    var startDateData;

    return {
        render: render,
        renderSingleDate: renderSingleDate,
        setValue: setValue
    };

    function render(employeeGroupId, productType) {
        return startDatesService.getPolicyStartDate(employeeGroupId, productType)
            .then(function (data) {
                startDateData = data;
                renderProductDates(startDateData);
                return {
                    setValue: setValue,
                    getStartDateData: function () {
                        return startDateData;
                    }
                };
            });
    }

    function setValue(value) {
        $('#'+config.id).val(value);
    }

    function doRender(data) {
        var supportText1i18nPostfix, supportText2i18nPostfix;
        if(config.supportTexti18nPostfix instanceof Function) {
            supportText1i18nPostfix = config.supportTexti18nPostfix(data, 1);
            supportText2i18nPostfix = config.supportTexti18nPostfix(data, 2);
        }
        var props = {
            id: config.id,
            mountOn: config.mountOn,
            inputName: config.inputName,
            i18nContext: config.i18nContext,
            supportText1i18nPostfix: supportText1i18nPostfix,
            supportText2i18nPostfix: supportText2i18nPostfix
        };
        $('#'+config.mountOn).replaceWith(__webpack_require__("e5+y")(props));
        $('#'+config.mountOn).localize();
        if (config.onChange) {
            $('#' + config.id).change(function (event) {
                config.onChange(event.target.value);
            });
        }
    }

    function renderProductDates(data) {
        if (!config.mountImmediateley) {
            doRender(data);
        }
        var startDate = data.minStartDate ? getDaysFromNow(data.minStartDate) : "-14d";
        var endDate = data.maxStartDate ? "+" + getDaysFromNow(data.maxStartDate) : "+30d";
        var input = $('#'+config.id);
        var element = document.getElementById(config.id); 
        element.minStartDate = data.minStartDate;
        element.maxStartDate = data.maxStartDate;
        element.excludedDates = data.excludedDates;

        $('.input-group.date').datepicker({
            format: "dd/mm/yyyy",
            container: '.input-group.date',
            autoclose: true,
            startDate: startDate,
            endDate: endDate,
            datesDisabled: data.excludedDates
        }).on('show', function () {
            var element = $('.datepicker.datepicker-dropdown.dropdown-menu');
            var requiredHeight = element.offset().top + element.outerHeight();
            var offset = requiredHeight - window.innerHeight;
            if (requiredHeight > window.innerHeight) {
                $('html,body').animate({scrollTop: offset}, 100);
            }
        });

        input.prop('disabled', false);
        $('#'+config.mountOn).show();

        $('.datepicker-cover-mobile').click(function () {
            $(this).parent('.date').datepicker('show');
        });

        var supportTextStyleClass;
        if(config.supportTextStyleClass instanceof Function) {
            supportTextStyleClass = config.supportTextStyleClass(data);
        }
        if (config.supportTextVisible instanceof Function) {
            var supportTextEval = config.supportTextVisible($.extend(true, {}, data));
            toggleSupportText(supportTextEval, supportTextStyleClass);
        } else {
            toggleSupportText((config.supportTextVisible === true), supportTextStyleClass);
        }
    }

    function toggleSupportText(flag, styleClass) {
        var supportText = $('#'+config.mountOn +' .policy-start-date-support-text');
        if (flag) {
            if(styleClass) {
                supportText.addClass(styleClass);
            }
            supportText.show();
        } else {
            supportText.hide();
        }
    }

    function renderSingleDate(renewalDateString) {
        var min = datePlusMinusOneDay(new Date(renewalDateString), false);
        min = dateUtils.dateFormatDayMonthYear(min);
        var minString = min.toLocaleString();
        var max = datePlusMinusOneDay(new Date(renewalDateString), true);
        max = dateUtils.dateFormatDayMonthYear(max);
        var maxString = max.toLocaleString();

        startDateData = {
            excludedDates: [],
            maxStartDate: maxString,
            minStartDate: minString,
            renewalDateInStartDateWindow: false
        };
        renderProductDates(startDateData);
        return {
            setValue: setValue,
            getStartDateData: function () {
                return startDateData;
            }
        };
    }
};

function registerValidationMethods() {
    $.validator.addMethod("dateRangeValidator", function(value, element) {
        if (/^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
            if (dateUtils.dateIsBetween(element.minStartDate, element.maxStartDate, value)) {
                //valid so far, check if exlucedDates have config
                if (element.excludedDates) {
                    return element.excludedDates.every(function(date) {
                        return !dateUtils.isSameDate(date, value);
                    });
                }
                return true;
            }
        }
        return false;
    }, errorByKey("policy.start.date.range.Invalid"));
}

function getDaysFromNow(date) {
    return dateUtils.getDaysFromNow(date) + 'd';
}

function datePlusMinusOneDay(date, plus){
    if(plus) {
        date.setDate(date.getDate()+1);
    } else {
        date.setDate(date.getDate()-1);
    }
    return date;
}


/***/ }),

/***/ "TNSw":
/***/ (function(module, exports, __webpack_require__) {

var events = __webpack_require__("yq58");

var Parameters = {
    EVENT: 'event',
    FORMTYPE: 'formType',
    FORMSTEP: 'formStep',
    STEPTYPE: 'stepType',
    MEMBER: 'member',
    ECOMMERCE: 'ecommerce',
    VALUE: 'value',
    ITEMNAME: 'itemName',
    ITEMTYPE: 'itemType',
    MARKETING_PREFERENCES: 'marketing_preferences',
    DOCUMENT_PREFERENCES: 'document_preferences',
    PEOPLE_COVERED: 'peopleCovered',
    TRANSACTION_ID: 'transaction_id',
    FACILITY: 'hospital',
    TREATMENT_TYPE: 'treatmentType',
    DESTINATION: 'destination',
    ADDON: 'addOn'
};

var Items = {

    PMI_CODE: 'PMI0811',
    DENTAL_PLUS: 'dental_plus',
    DENTAL_STANDARD: 'dental'

};

var GLOBAL_CONFIG = {
    Debug: true,
    GA: {
        STAGING: 'XYZ',
        PRODUCTION: 'ABC',
    },
    GTM: {
        STAGING: 'XYZ',
        PRODUCTION: 'ABC',
    },
    Parameters : Parameters,
    Items: Items,
    Journeys : {
        GROUP_TRANSFER: 'group_transfer',
        GROUP_JOIN: 'group_join',
        INT_GROUP_JOIN: 'int_group_join'
    },
    Forms:{
        Events: {
            FormEvents : events.FormEvents,
            FormStepTypes: events.FormStepTypes
        }
    }
};

module.exports = {
    GLOBAL_CONFIG : GLOBAL_CONFIG,
};

/***/ }),

/***/ "VgQt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by c_razmuss_a on 25/01/2018.
 */


/**
 * Asserts if provided val exists, throws error with msg if it doesn't
 * @param val value to be checked for "truthy" if (val)
 * @param msg message to be included in the error
 */
function assertExists(val, msg) {
    if (val) {
        return;
    } else {
        throw new Error(msg);
    }
}

/**
 * Asserts if provided val is of type, throws error with msg if type is incorrect
 * @param val value to be checke for type
 * @param type expected type
 * @param msg message to be included in the error if type doesn't match
 */
function assertType(val, type, msg){
    if (typeof val !== type) {
        throw new Error(msg);
    }
}

module.exports.assertExists = assertExists;
module.exports.assertType = assertType;



/***/ }),

/***/ "WMth":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function isGroupSuspended(data) {
    return (data && data.renewalDateInStartDateWindow);
}

function getSupportTexti18nPostfix(data, postfixId) {
    if(isGroupSuspended(data)) {
        return 'startDateSupportTextSuspended' + postfixId;
    } else {
        return 'startDateSupportText' + postfixId;
    }
}

function getSupportTextStyleClass(data) {
    var style;
    if(isGroupSuspended(data)) {
        style = 'policy-start-date-support-text--pumpkin';
    }
    return style;
}

module.exports.getSupportTexti18nPostfix = getSupportTexti18nPostfix;
module.exports.getSupportTextStyleClass = getSupportTextStyleClass;


/***/ }),

/***/ "Ytzv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__("7t+N");

function getIsUserLoggedIn(){
    var userLoggedInPromise = $.Deferred();
    $.get( "/intgroups" + '/rest/accessManagement/loginStatus')
        .done(function (data) {
                console.log("getIsUserLoggedIn : " + data);
                if(data.loggedIn===true){
                    userLoggedInPromise.resolve(true);
                }else{
                    userLoggedInPromise.resolve(false);
                }
        })
        .fail(function(jqXHR, textStatus, error) {
            console.log( "error: status = %s", jqXHR.status);
            console.log( "error: responseText = %s", jqXHR.responseText);
            console.log( "error: textStatus = %s", textStatus);
            console.log( "error: error = %s", error);
            userLoggedInPromise.resolve(false);
        });

    return userLoggedInPromise.promise();
}

module.exports.getIsUserLoggedIn = getIsUserLoggedIn;

/***/ }),

/***/ "e5+y":
/***/ (function(module, exports, __webpack_require__) {

var jade = __webpack_require__("TBTh");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (i18nContext, id, inputName, mountOn, supportText1i18nPostfix, supportText2i18nPostfix) {
buf.push("<div" + (jade.attr("id", mountOn, true, true)) + " class=\"form-group form-group--row full\">");
var i18nPrefix = (i18nContext) ? i18nContext : "details.policy."
var i18nSuppText1Postfix = (supportText1i18nPostfix) ? supportText1i18nPostfix : "startDateSupportText1"
var i18nSuppText2Postfix = (supportText2i18nPostfix) ? supportText2i18nPostfix : "startDateSupportText2"
buf.push("<div class=\"half di-label policy-start-date-text\"><span" + (jade.attr("data-i18n", i18nPrefix + "startDate", true, true)) + "></span><div class=\"di-label__support policy-start-date-support-text\"><div" + (jade.attr("data-i18n", "[html]" + i18nPrefix + i18nSuppText1Postfix, true, true)) + ">Your group scheme is in renewal negotiations&nbsp;</div><div" + (jade.attr("data-i18n", i18nPrefix + i18nSuppText2Postfix, true, true)) + ">so only limited dates can be picked at this point</div></div></div><div class=\"half\"><div class=\"input-group date\"><div class=\"datepicker-cover-mobile\"></div>");
var name = (inputName) ? inputName : "policyInfo.basicPolicyInfo.policyDate";
buf.push("<input" + (jade.attr("id", id, true, true)) + " type=\"text\" placeholder=\"DD/MM/YYYY\"" + (jade.attr("name", name, true, true)) + " required disabled data-rule-dateRangeValidator=\"true\" data-msg=\"Please select a date\"" + (jade.attr("data-i18n", "[data-msg]" + i18nPrefix + "startDate-msg", true, true)) + " autocomplete=\"off\" class=\"form-control datepicker\"><span class=\"input-group-addon\"><i class=\"glyphicon datepicker__icon\"></i></span></div></div></div>");}.call(this,"i18nContext" in locals_for_with?locals_for_with.i18nContext:typeof i18nContext!=="undefined"?i18nContext:undefined,"id" in locals_for_with?locals_for_with.id:typeof id!=="undefined"?id:undefined,"inputName" in locals_for_with?locals_for_with.inputName:typeof inputName!=="undefined"?inputName:undefined,"mountOn" in locals_for_with?locals_for_with.mountOn:typeof mountOn!=="undefined"?mountOn:undefined,"supportText1i18nPostfix" in locals_for_with?locals_for_with.supportText1i18nPostfix:typeof supportText1i18nPostfix!=="undefined"?supportText1i18nPostfix:undefined,"supportText2i18nPostfix" in locals_for_with?locals_for_with.supportText2i18nPostfix:typeof supportText2i18nPostfix!=="undefined"?supportText2i18nPostfix:undefined));;return buf.join("");
}

/***/ }),

/***/ "eURo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__("7t+N");
var analyticsUtil = __webpack_require__("0v5J");
var config = __webpack_require__("TNSw");

var formStartName = config.GLOBAL_CONFIG.Forms.Events.FormEvents.FORM_START;
var formStepCompleteName = config.GLOBAL_CONFIG.Forms.Events.FormEvents.FORM_STEP_COMPLETE;
var intGroupJoinName = config.GLOBAL_CONFIG.Journeys.INT_GROUP_JOIN;
var startName = config.GLOBAL_CONFIG.Forms.Events.FormStepTypes.START;
var detailsName = config.GLOBAL_CONFIG.Forms.Events.FormStepTypes.DETAILS;

function addAnalyticsHandlers() {

    var pushed = false;

    $('.half').click(function () {
        if(!pushed) {
            pushed = true;
            analyticsUtil.formPush(formStartName, intGroupJoinName, 0, startName);
        }
    });

    $('#next').click(function () {

        analyticsUtil.formPush(formStepCompleteName, intGroupJoinName, 1, detailsName);

    });

}

module.exports.addAnalyticsHandlers = addAnalyticsHandlers;


/***/ }),

/***/ "fJHJ":
/***/ (function(module, exports, __webpack_require__) {

var jade = __webpack_require__("TBTh");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (employeeGroups, i18nContext, id, inputName, mountOn, readOnly, undefined) {
buf.push("<div" + (jade.attr("id", mountOn, true, true)) + " class=\"form-group form-group--row\">");
var i18nPrefix = (i18nContext) ? i18nContext : "details.policy."
buf.push("<label" + (jade.attr("for", id, true, true)) + (jade.attr("data-i18n", i18nPrefix + "employeeGroup", true, true)) + " class=\"half mobile-text-indent copy3 employee-group-text\">What Vhi employee group do you belong to?</label><div class=\"half\"><div class=\"select-container\">");
var attr = (readOnly) ? { disabled: "" } : {};
if (!readOnly) {
buf.push("<span class=\"di-support-text employee-group-support-label\">Select from the dropdown</span>");
}
var name = (inputName) ? inputName : "policyInfo.basicPolicyInfo.employeeGroup"
buf.push("<select" + (jade.attrs(jade.merge([{"id": jade.escape(id),"name": jade.escape(name),"data-style": "select-container__button","required": true,"data-i18n": (typeof (jade_interp = "[data-msg]" + i18nPrefix + "employeeGroup-msg") == "string" ? jade.escape(jade_interp) : jade_interp),"class": "form-control selectpicker"},attr]), true)) + "><option value=\"\">Please select</option>");
// iterate employeeGroups
;(function(){
  var $$obj = employeeGroups;
  if ('number' == typeof $$obj.length) {

    for (var groupId = 0, $$l = $$obj.length; groupId < $$l; groupId++) {
      var groupName = $$obj[groupId];

buf.push("<option" + (jade.attr("value", groupId, true, true)) + ">" + (jade.escape(null == (jade_interp = groupName) ? "" : jade_interp)) + "</option>");
    }

  } else {
    var $$l = 0;
    for (var groupId in $$obj) {
      $$l++;      var groupName = $$obj[groupId];

buf.push("<option" + (jade.attr("value", groupId, true, true)) + ">" + (jade.escape(null == (jade_interp = groupName) ? "" : jade_interp)) + "</option>");
    }

  }
}).call(this);

buf.push("</select></div></div></div>");}.call(this,"employeeGroups" in locals_for_with?locals_for_with.employeeGroups:typeof employeeGroups!=="undefined"?employeeGroups:undefined,"i18nContext" in locals_for_with?locals_for_with.i18nContext:typeof i18nContext!=="undefined"?i18nContext:undefined,"id" in locals_for_with?locals_for_with.id:typeof id!=="undefined"?id:undefined,"inputName" in locals_for_with?locals_for_with.inputName:typeof inputName!=="undefined"?inputName:undefined,"mountOn" in locals_for_with?locals_for_with.mountOn:typeof mountOn!=="undefined"?mountOn:undefined,"readOnly" in locals_for_with?locals_for_with.readOnly:typeof readOnly!=="undefined"?readOnly:undefined,"undefined" in locals_for_with?locals_for_with.undefined: false?undefined:undefined));;return buf.join("");
}

/***/ }),

/***/ "g+w9":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
    'use strict';

    var testUrlParameters;

    function getAllUrlParameters() {
        if (testUrlParameters) {
            return testUrlParameters;
        }
        return window.location.search.substring(1);
    }

    function getUrlPath() {
        return window.location.pathname;
    }

    function redirectToUrl(destinationUrl) {
        window.location.replace(destinationUrl);
    }

    function navigateToUrl(destinationUrl) {
        window.location.href = destinationUrl;
    }

    return {
        getUrlParameter: function (paramName) {
            var params = getAllUrlParameters();
            console.log(params);
            var paramList = params.split('&');

            for (var i = 0; i < paramList.length; i++) {
                var param = paramList[i].split('=');
                if (param[0] === paramName) {
                    return param[1];
                }
            }
        },
        getAllUrlParameters: getAllUrlParameters,
        setTestUrlParameters: function (urlParameters) {
            testUrlParameters = urlParameters;
        },
        redirectToUrl: redirectToUrl,
        navigateToUrl: navigateToUrl,
        getUrlPath: getUrlPath
    };
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "iPHx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("7t+N");
var stickyHeader = __webpack_require__("j7WF");

/**
 * Initialises the header state.
 * <p>
 * Takes a promise as argument that return true/false.
 * If the promise resolves to true, the log out CTA is displayed.
 * For all other resolution states the log out CTA in NOT displayed.
 * </p>
 */
function init(isLoggedIn) {
    stickyHeader.apply('nav-bar-top', 'page-container', false);
    showHideLogoutCTA(isLoggedIn);
}

function initWithLoginCta(isLoggedIn, isGroups) {
    stickyHeader.apply('nav-bar-top', 'page-container', false);

    if (isGroups || (!isGroups && isLoggedIn)) {
        var loginButtonTemplate = __webpack_require__("7Iys");
        var html = loginButtonTemplate({isLoggedIn: isLoggedIn});
        var $placeHolder = $('#login-btn-dynamic-content');
        $placeHolder.html(html);
    }
}

/**
 * Displays or hides the Logout CTA.
 * @param aBoolean if true the Logout CTA is displayed, remains hidden otherwise.
 */
function showHideLogoutCTA(aBoolean){
    if(aBoolean===true){
        $('#nav-logout').show();
    }else{
        $('#nav-logout').hide();
    }
}

module.exports = {
    init: init,
    initWithLoginCta: initWithLoginCta
};

/***/ }),

/***/ "iyeL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ajaxHandler = __webpack_require__("CCE4");
var dateUtils = __webpack_require__("lglL");
var assertType = __webpack_require__("VgQt").assertType;

/**
 * Get allowed values for policy start date for given employeeGroup and productType
 * returns values in user format
 */
function getPolicyStartDate(employeeGroupId, productType) {
    assertType(employeeGroupId, 'string', 'Invalid employeeGroup value '+ employeeGroupId +'- expected string');
    assertType(productType, 'string', 'Invalid productType value '+ productType +'- expected string');
    return ajaxHandler.ajaxGetJson({url: "/intgroups" + '/rest/dates/startDates?categoryId=' + employeeGroupId + '&productType=' + productType})
        .then(function (data){
            var result = {};
            if (data.minStartDate) {
                result.minStartDate = dateUtils.format2user(data.minStartDate);
            }
            if (data.maxStartDate) {
                result.maxStartDate = dateUtils.format2user(data.maxStartDate);
            }
            if (data.excludedDates) {
                var excludedDates = [];
                data.excludedDates.forEach(function (dt) {
                    var newDt = dateUtils.format2user(dt);
                    excludedDates.push(newDt);
                });
                result.excludedDates = excludedDates;
            }
            result.renewalDateInStartDateWindow = data.renewalDateInStartDateWindow;
            return result;
        })
        .fail(ajaxHandler.handleError('Could not retrieve product type dates'));
}

module.exports.getPolicyStartDate = getPolicyStartDate;

/***/ }),

/***/ "juAn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//uses 'international' namespace to avoid conflicts with other apps
module.exports = __webpack_require__("Eb2/").namespace('international');

/***/ }),

/***/ "kMMZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("7t+N");
__webpack_require__("f9KE");
var futureRules = __webpack_require__("s5DP");

var formErrorsConfig = {
    errorElementIdPostfix : "-error",
    errorElement : "span",
    errorClass : "help-block",
    parentErrorClass: "has-error",
    groupParentSelector: ".form-group"
};

var defaultConfig = {
    invalidHandler: scrollToFirstError,
    onkeyup : function(element, event) {
        // Avoid revalidate the field when pressing one of the following keys
        // Shift       => 16
        // Ctrl        => 17
        // Alt         => 18
        // Caps lock   => 20
        // End         => 35
        // Home        => 36
        // Left arrow  => 37
        // Up arrow    => 38
        // Right arrow => 39
        // Down arrow  => 40
        // Insert      => 45
        // Num lock    => 144
        // AltGr key   => 225
        var excludedKeys = [
            16, 17, 18, 20, 35, 36, 37,
            38, 39, 40, 45, 144, 225
        ];

        if ( event.which === 9 || $.inArray( event.keyCode, excludedKeys ) !== -1 ) {
            return;
        }

        futureRules.evalMinLength(element);

        this.element(element);
        if (this.settings.onkeyupCallback) {
            this.settings.onkeyupCallback();
        }

    },
    onfocusout : function(element, event) {
        //ignore date picker element, and bootstrap-select
        if ($(element).parent().is('.input-group.date, .bootstrap-select')) {
            return;
        }
        futureRules.evalMinLength(element, true);
        this.element(element);
        if (this.settings.onfocusoutCallback) {
            this.settings.onfocusoutCallback();
        }
    },
    ignore : "input.combobox, select.combobox",
    groups: {},
    highlight : function(element) {
        $(element).closest(formErrorsConfig.groupParentSelector).addClass(formErrorsConfig.parentErrorClass);
    },
    unhighlight : function(element) {
        $(element).closest(formErrorsConfig.groupParentSelector).removeClass(formErrorsConfig.parentErrorClass);
    },
    errorElement : formErrorsConfig.errorElement,
    errorClass : formErrorsConfig.errorClass,
    errorPlacement : handleErrorPlacement,
    submitHandler : function(form) {
        form.submit();
    }
};

/**
 * Creates jquery validator for the provided form and config object
 * form - jquery selected form
 * configObject - to overwrite default config in this file. Accepts all options defined in https://jqueryvalidation.org/validate/
 *  in addition accepts the following:
 *      onkeyupCallback - function to be invoked at the end of onkeyup event
 *      onfocusoutCallback - function to be invoked at the end of onfocusout event
 */
function createValidator(form, configObject) {
    var configToApply = $.extend({}, defaultConfig, configObject);
    form.on("submit.validate", function(event) {
        futureRules.applyAllFutureRules(form);
    });

    var formValidator = form.validate(configToApply);

    form.on("change", '.selectpicker, .datepicker, input[type=radio], input[type=checkbox], .combobox-namedElement' , function(event) {
        formValidator.element(event.target);
        if (formValidator.settings.onkeyupCallback) {
            formValidator.settings.onkeyupCallback();
        }
    });

    return formValidator;
}

function handleErrorPlacement(error, element) {
    removeExistingError(element.attr('id'));
    //for radio buttons need to go 2 levels up to avoid the label
    if (element.attr('type') === 'radio') {
        error.appendTo(element.closest('.radio-button-group'));
        return;
    }

    if (element.parent(".input-group, .combobox-container").length) {
        error.insertAfter(element.parent());
    } else {
        error.appendTo(element.parent());
    }
}

/*
 * Removes an existing error from the specified element input. This is to ensure we only
 * ever show a single error message per field.
 */
function removeExistingError(elementId) {
    // e.g. select and existing "#staffNumber-error" error element, and remove it
    $('#' + elementId + formErrorsConfig.errorElementIdPostfix).remove();
}

/*
 * Scrolls the page to the first error following a failed form submission. This takes the height
 * of the nav bar into account also.
 */
function scrollToFirstError(event, validator) {
    if (!validator.numberOfInvalids()) {
        return;
    }

    var $formGroupParent = $(validator.errorList[0].element).parents('.form-group').first();

    if($formGroupParent.length) {
        var firstErrorOffset = $formGroupParent.offset().top;
        var navBarHeight = $('#nav-bar-top').height();

        var offset = firstErrorOffset - navBarHeight - 30;

        $('html, body').animate({
            scrollTop: offset
        }, 750);
    }
}

var validationMessages, validationRegexes = {
    "intl.mobile.code": "(\\\\+\\\\d{1,4})",
    "intl.mobile.number": "^[0-9]{7,13}$"
};


var loading;

/*
 * Loads the validation regexs and the validation messages for use with the
 * inline validation
 */
function loadValidationMessages() {
    loading = $.ajax({
        type : "GET",
        url : "/online-services/validations",
        dataType : 'json',
        contentType : 'application/json; charset=utf-8'
    }).done(function(data) {
        validationMessages = $.extend(validationMessages, data.validationMessages);
        validationRegexes = $.extend(validationRegexes, data.validationRegexes);
        console.log('online-services error messages loaded');
    }).fail(function(e) {
        console.log('Failed to load validation messages', e);
    });
    return loading;
}

/*
 * Function to retrieve an error value based on the specified keys. It
 * returns the key used, if no value is found.
 *
 * @param fallbackMessageKey The fallback message key to use, for when the
 * errorMessage key is undefined. This is a required parameter.
 * @param errorMessageKey The error message key to use. This is an optional
 * parameter.
 */
function getErrorMessage(fallbackMessageKey, errorMessageKey) {
    if (typeof validationMessages !== 'undefined') {
        console.log("Error key = %s, default key = %s", errorMessageKey, fallbackMessageKey);
        var theKey = errorMessageKey ? errorMessageKey : fallbackMessageKey;
        return validationMessages[theKey] ? validationMessages[theKey] : theKey;
    } else {
        return fallbackMessageKey;
    }
}

/*
 * Method to provide customized error messages from alfresco.
 * bridges the gap of jquery-validator sync messages call to async retrieval of alfresco content
*/
function errorByKey(key) {
    return function(rule, element) {
        if (loading.state() === 'pending') {
                console.error('Unable to fetch validation error messages in time before validation');
        }
        return getErrorMessage(key);
    };
}

/**
 * Binds a new function which is able to render server side validation messages
 * @param formSelector - selector for form where error messages must be displayed
 * @returns {Function} handles server output
 */
function renderServerErrors(formSelector) {
    return function(jqXHR, message, result) {

            if (jqXHR.status === 422 && jqXHR.responseJSON) {
                result = jqXHR.responseJSON;
                var errorArray = result.fieldErrors.reduce(function(errorArray, fieldError){
                    var name = fieldError.field;
                    var validator = $(formSelector).validate();
                    var element = validator.currentElements.filter("[name='"+name+"']").get(0);
                    if (element) {
                        var message = validator.defaultMessage(element, {method: fieldError.code});
                        errorArray[name] = message;
                    } else {
                        console.log("Unable to find field "+ name +" in form with selector " + formSelector);
                    }

                    return errorArray;
                }, {});


                $(formSelector).validate().showErrors(errorArray);
            }
        };
}

/**
 * validates form
 * to be used instead of $().valid() method when futureRules are at play
 * @param formSelector
 * @returns boolean true if form is valid
 */
function validate(formSelector) {
    futureRules.applyAllFutureRules(formSelector);
    return $(formSelector).valid();
}

/**
 * checks if form is valid, without rendering error messages
 * @param formSelector
 * @returns boolean - true if form is valid and no futureRules remain
 */
function isValid(formSelector) {
    return $(formSelector).validate().checkForm();
}

//fetch error messages on load
loadValidationMessages();

module.exports.createValidator = createValidator;
module.exports.renderServerErrors = renderServerErrors;
module.exports.validate = validate;
module.exports.isValid = isValid;

module.exports.errorByKey = errorByKey;
module.exports.getErrorMessage = getErrorMessage;
module.exports.validationRegexes = validationRegexes;

//for convenience expose frequently used methodsd of futureRules
module.exports.renderingDone = futureRules.renderingDone;
module.exports.hasNoFutureRules = futureRules.hasNoFutureRules;
module.exports.elemHasNoFutureRule = futureRules.elemHasNoFutureRule;

//for testing only
module.exports.loading = loading;
module.exports.loadValidationMessages = loadValidationMessages;





/***/ }),

/***/ "lQbp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("7t+N");
var ajaxHandler = __webpack_require__("CCE4");
var store = __webpack_require__("juAn");

//const
var cacheKey = 'intlGroupSchemeBasicInfo';
/**
 * as the group scheme data are related to session there is no need to have multiple concurrent requests
 */
var fetchInProgress;

function getSchemeInfo(refresh, groupSchemeToken) {
    if (refresh !== true && store.session.has(cacheKey)) {
        return $.Deferred().resolve(store.session.get(cacheKey)).promise();
    } else {
        return fetchGroupScheme(groupSchemeToken);
    }
}

function getContactInformation(refresh) {
    if (refresh !== true && store.session.has(cacheKey)) {
        return $.Deferred().resolve(store.session.get(cacheKey).vhiContacts[0]).promise();
    } else {
        return fetchGroupScheme()
            .then(function(groupSchemeBasicInfo) {
                return groupSchemeBasicInfo.vhiContacts[0];
            });
    }
}

function fetchGroupScheme(groupSchemeToken) {
    if (fetchInProgress) {
        return fetchInProgress;
    } else {
        if (groupSchemeToken) {
            fetchInProgress = ajaxHandler.ajaxGetJson({url: "/intgroups" + '/rest/schemeByToken', jsonString: {'token': groupSchemeToken} })
                .then(function (groupSchemeBasicInfo) {
                    store.session(cacheKey, groupSchemeBasicInfo);
                    return groupSchemeBasicInfo;
                })
                .always(function () {
                    fetchInProgress = null;
                });
        } else {
            fetchInProgress = ajaxHandler.ajaxGetJson({ url: "/intgroups" + '/rest/scheme'})
                .then(function (groupSchemeBasicInfo) {
                    store.session(cacheKey, groupSchemeBasicInfo);
                    return groupSchemeBasicInfo;
                })
                .always(function () {
                    fetchInProgress = null;
                });
        }
        return fetchInProgress;
    }
}
module.exports.getSchemeInfo = getSchemeInfo;
module.exports.getContactInformation = getContactInformation;

/***/ }),

/***/ "lglL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var moment = __webpack_require__("PJh5");

var userDateFormat = 'DD/MM/YYYY';
var serverDateFormat = 'YYYY-MM-DD';
var benefitsDateFormat = 'DDMMYYYY';
var userDateFormatRegex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
var serverDateFormatRegex = /^(\d{4})-(\d{2})-(\d{2})$/;
var benefitsDateFormatRegex = /^(\d{2})(\d{2})(\d{4})$/;

function getDate(date) {
    if (date instanceof Date) {
        return date;
    }
    if (typeof date === 'string') {
        var res = userDateFormatRegex.exec(date);
        if (res) {
            return new Date(res[3], res[2] - 1, res[1]);
        }
        res = serverDateFormatRegex.exec(date);
        if (res) {
            return new Date(res[1], res[2] - 1, res[3]);
        }
        res = benefitsDateFormatRegex.exec(date);
        if (res) {
            return new Date(res[3], res[2] - 1, res[1]);
        }
    }
    if (typeof date === 'number') {
        return new Date(date);
    }
    return '';
}

function format2server(date) {
    var dt = getDate(date);
    if (dt) {
        var y = dt.getFullYear();
        var m = dt.getMonth() + 1;
        var d = dt.getDate();
        if (m < 10) {
            m = '0' + m;
        }
        if (d < 10) {
            d = '0' + d;
        }
        return '' + y + '-' + m + '-' + d;
    }
    return '';
}

function format2user(date) {
    var dt = getDate(date);
    if (dt) {
        var y = dt.getFullYear();
        var m = dt.getMonth() + 1;
        var d = dt.getDate();
        if (m < 10) {
            m = '0' + m;
        }
        if (d < 10) {
            d = '0' + d;
        }
        return '' + d + '/' + m + '/' + y;
    }
    return '';
}

function format4benefits(date) {
    var dt = getDate(date);
    if (dt) {
        var y = dt.getFullYear();
        var m = dt.getMonth() + 1;
        var d = dt.getDate();
        if (m < 10) {
            m = '0' + m;
        }
        if (d < 10) {
            d = '0' + d;
        }
        return '' + d + m + y;
    }
    return '';
}

function getDaysTotal(date) {
    var dt = getDate(date);
    if (dt) {
        var days = dt / (1000 * 60 * 60 * 24);
        return Math.ceil(days);
    }
    return 0;
}

function getYearsTotal(date) {
    var dt = getDate(date);
    if (dt) {
        var diffMs = Date.now() - dt.getTime();
        var ageDate = new Date(diffMs);
        return Math.abs(ageDate.getFullYear() - 1970);
    }
    return 0;
}

function getDaysFromNow(date) {
    var firstDate = moment(date, 'DD/MM/YYYY').startOf('day');
    var todayDate = moment(new Date()).startOf('day');

    if(firstDate){
        return firstDate.diff(todayDate, 'days');
    }

    return 0;
}

function dateIsBetween(startDate, endDate, checkDate) {
    var startDays = getDaysTotal(startDate);
    var endDays = getDaysTotal(endDate);
    var checkDays = getDaysTotal(checkDate);
    return startDays <= checkDays && checkDays <= endDays;
}

function isSameDate(date1, date2) {
    return getDaysTotal(date1) === getDaysTotal(date2);
}

function isAdult(date) {
    return 18 <= getYearsTotal(date);
}
/*
 * Param - Date object
 * Return - Date string in DD-MM-YYYY format
 * Also prepend 0s if not present on day or month
  * */
function dateFormatDayMonthYear(date) {
    var d = new Date(date);
    var month = String(d.getMonth() + 1);
    var day = String(d.getDate());
    var year = String(d.getFullYear());

    if (month.length < 2) {month = '0' + month;}
    if (day.length < 2) {day = '0' + day;}

    return day+'/'+month+'/'+year;
}

module.exports = {
    serverDateFormat: serverDateFormat,
    userDateFormat: userDateFormat,
    benefitsDateFormat: benefitsDateFormat,
    userDateFormatRegex: userDateFormatRegex,
    serverDateFormatRegex: serverDateFormatRegex,
    benefitsDateFormatRegex: benefitsDateFormatRegex,
    getDate: getDate,
    format2server: format2server,
    format2user: format2user,
    format4benefits: format4benefits,
    getDaysTotal: getDaysTotal,
    getYearsTotal: getYearsTotal,
    getDaysFromNow: getDaysFromNow,
    dateIsBetween: dateIsBetween,
    isSameDate: isSameDate,
    isAdult: isAdult,
    dateFormatDayMonthYear: dateFormatDayMonthYear
};


/***/ }),

/***/ "lwx0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__("7t+N");
var jqueryI18next = __webpack_require__("+ZPT");
var i18next = __webpack_require__("QCdE");
var backend = __webpack_require__("OcWW");
var cache = __webpack_require__("IdM4");

var defaultOptions = {
    //debug: true,
    lng: 'en',
    fallbackLng: 'en',
    //ns: [],
    interpolation: {'escapeValue': false},
    backend: {
        loadPath: function(lng, ns){
            if(ns.indexOf('plan-names') !== -1){
                return '/online-services/plan-names';
            }else{
                return '/groups/' + 'locales/' + lng + '/' + ns + '.json';
            }
        }
    },
    cache:
        {
            enabled: true,
            // prefix for stored languages
            prefix: 'i18next_res_',
            // expiration (10 mins)
            expirationTime: 10 * 60 * 1000
        }
};

function doSetup(options) {
    var mergedOpts = $.extend({}, defaultOptions, options);

    jqueryI18next.init(i18next, $);

    var deferred = $.Deferred();

    i18next.use(backend)
        .use(cache)
        .init(mergedOpts, function(err, t) {
            if (err) {
                console.error(err);//all bad failed to initialize
            } else {
                deferred.resolve(i18next); //now we can translate
            }
        });

    return deferred.promise();
}

/**
 * Returns a function to be used for jquery validator.
 * Validator doesn't support promises, thus we expect i18n has already been initialized
 * if you need regular translations in javascript better use i18next resolved value from i18n.init() promise
 * @param key
 * @returns {Function}
 */
function translate(key) {
    return function() {
        return i18next.t(key);
    };
}

module.exports = {
    doSetup: doSetup,
    translate: translate
};



/***/ }),

/***/ "pHlT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * This service provides session group scheme information, including basic contact information
 * uses session storage to cache groupScheme information
 * if request has been initiated and not yet resolved any new requests will return the promise of the first request
 * @author c_razmuss_a (Arturs Razmuss) on 16/02/2018
 */
var $ = __webpack_require__("7t+N");
var ajaxHandler = __webpack_require__("CCE4");
var store = __webpack_require__("JOWb");

//const
var cacheKey = 'groupSchemeBasicInfo';
/**
 * as the group scheme data are related to session there is no need to have multiple concurrent requests
 */
var fetchInProgress;

function getGroupScheme(refresh, groupSchemeToken) {
    if (refresh !== true && store.session.has(cacheKey)) {
        return $.Deferred().resolve(store.session.get(cacheKey)).promise();
    } else {
        return fetchGroupScheme(groupSchemeToken);
    }
}

function getContactInformation(refresh) {
    if (refresh !== true && store.session.has(cacheKey)) {
        return $.Deferred().resolve(store.session.get(cacheKey).vhiContacts[0]).promise();
    } else {
        return fetchGroupScheme()
            .then(function(groupSchemeBasicInfo) {
                return groupSchemeBasicInfo.vhiContacts[0];
            });
    }
}

function fetchGroupScheme(groupSchemeToken) {
    if (fetchInProgress) {
        return fetchInProgress;
    } else {
        // The case when user hasn't visited "/groups" page before "/myvhi" and there is no GroupScheme info in session
        // (can be called when displaying custom enrolment content)
        if(groupSchemeToken) {
            fetchInProgress = ajaxHandler.ajaxGetJson({url: '/groups/rest/schemeByToken', jsonString: {'token': groupSchemeToken} })
                .then(onSuccess)
                .always(onAlways);
        } else {
            fetchInProgress = ajaxHandler.ajaxGetJson({ url: '/groups/rest/scheme'})
                .then(onSuccess)
                .always(onAlways);
        }
        return fetchInProgress;
    }
    
    function onSuccess(groupSchemeBasicInfo) {
        store.session(cacheKey, groupSchemeBasicInfo);
        return groupSchemeBasicInfo;
    }

    function onAlways() {
        fetchInProgress = null;
    }
}

module.exports.getGroupScheme = getGroupScheme;
module.exports.getContactInformation = getContactInformation;


/***/ }),

/***/ "r1X9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__("7t+N");
__webpack_require__("b4+h");
__webpack_require__("7sE5");
var futureRules = __webpack_require__("s5DP");
var validation = __webpack_require__("kMMZ");
var dateUtils = __webpack_require__("lglL");
var getErrorMessage = __webpack_require__("kMMZ").getErrorMessage;


// Store the old validation methods for delegation purposes
var $oldRequired = $.validator.methods.required;
var $oldCreditCard = $.validator.methods.creditcard;
var $oldIban = $.validator.methods.iban;
var $oldRange = $.validator.methods.range;

/**
 * Initialises common jquery validation functions
 */
function initValidations() {
    console.log("Initialising validations");

    addRequiredValidator();
    addGenericStringValidator();
    addPpsnValidator();
    addMobileNumberValidator();
    addIntlMobileNumberValidator();
    addIEAndUKMobileNumberValidator();
    addContactNumberValidator();
    addEmailAddressValidator();
    addPolicyNumberValidator();
    addDateFormatValidator();
    addBicValidator();
    addIbanValidator();
    addCvvValidator();
    addCreditCardNumberValidator();
    addCardExpiryDateValidator();
    addZipCodeValidator();
    addLcrLoadingValidator();
    addMonetaryAmountValidator();
    addRangeValidator();
    addInsurancePeriodValidator();
    addBreakPeriodValidator();
    addDateGreaterThanValidator();
    addDateLessThanValidator();
    addChildAgeValidator();
    addDatePeriodGreaterThanZeroValidator();
    addDateAfter2008Validator();
    addPersonNamesValidator();
    addMax9AdultsLimitValidator();
    addMax9ChildLimitValidator();
    addGreaterThanStartValidator();
    addAdultAgeValidator();
    addFutureBirthDateValidator();

    console.log("Initialising validations done.");
}

function addInsurancePeriodValidator() {
    $.validator.addMethod('insurance_period_require_from_group',
        $.validator.methods.require_from_group,
        function () {
            return getErrorMessage("previous.insurance.period.invalid");
        });
}

function addBreakPeriodValidator() {
    $.validator.addMethod('break_period_require_from_group',
        $.validator.methods.require_from_group,
        function () {
            return getErrorMessage("break.period.invalid");
        });
}


function addLcrLoadingValidator() {
    $.validator.addMethod(
        "validLoading",
        function (value, element, options) {
            if ((value === null) || (value === undefined)) {
                return false;
            } else {
                if (value % 2 !== 0) {
                    return false;
                } else {
                    if ((value < 0) || (value > 70)) {
                        return false;
                    }
                }
            }
            return true;
        },
        function (options) {
            return getErrorMessage('lcr.loading.invalid', options.errorKey);
        });
}

function addDatePeriodGreaterThanZeroValidator() {
    $.validator.addMethod('datePeriodGreaterThanZero', function (value, element, options) {
        var compareValue = $(element).parents('.form-group').find(options.compareSelector).val();
        console.log("Add value %s to selector value %s ", Number(value), Number(compareValue));
        return (Number(compareValue) + Number(value)) > 0;

    },
        function (options) {
            return getErrorMessage(options.errorKey);
        });
}


function addDateGreaterThanValidator() {
    $.validator.addMethod(
        "dateGreaterThan",
        function (value, element, options) {
            if (shouldValidateField(element)) {
                return true;
            }

            var baseElemDate = Date.parseExact(value, 'dd/MM/yyyy');
            if (baseElemDate === null) {
                console.log("Invalid date format on base Eleemnt input");
                return false;
            }
            console.log("Using a specific selector passed ", baseElemDate);

            var comparisonDate = new Date();
            if (options && typeof options === 'string') {
                Date.parseExact(options, 'yyyy-MM-dd');
            }

            if (comparisonDate === null) {
                console.log("Invalid date format on base comparison date input");
                return false;
            }

            console.log("Compaing against date " + comparisonDate);
            console.log("Comparison check is " + baseElemDate.compareTo(comparisonDate));
            if (baseElemDate.compareTo(comparisonDate) < 0) {
                console.log("Greater than check result = false");
                return false;
            } else {
                console.log("Greater than check result = true");
                return true;
            }
        },
        function (options) {
            return getErrorMessage("The end date must be after the start date", options.errorKey);
        });
}


function addDateLessThanValidator() {
    $.validator.addMethod(
        "dateLessThan",
        function (value, element, options) {
            if (shouldValidateField(element)) {
                return true;
            }

            var baseElemDate = Date.parseExact(value, 'dd/MM/yyyy');
            if (baseElemDate === null) {
                console.log("Invalid date format on base Eleemnt input");
                return false;
            }

            var comparisonDate = new Date();
            if (options && typeof options === 'string') {
                Date.parseExact(options, 'yyyy-MM-dd');
            }

            if (comparisonDate === null) {
                console.log("Invalid date format on base comparison date input");
                return false;
            }

            console.log("Compaing against date " + comparisonDate);
            console.log("Comparison check is " + baseElemDate.compareTo(comparisonDate));
            if (baseElemDate.compareTo(comparisonDate) < 0) {
                console.log("Date less than validation result=true");
                return true;
            } else {
                console.log("Date less than validation result=false");
                return false;
            }
        },
        function (options) {
            return getErrorMessage("The end date must be after the start date", options.errorKey);
        });
}



function addDateAfter2008Validator() {
    $.validator.addMethod(
        "dateAfter2008",
        function (value, element, options) {
            if (this.optional(element)) {
                return true;
            }

            console.log("Verifying date %s is after 2008.", value);

            /**
             * This is added to to trigger validation of the fromDate on the toDate blur event.
             */

            if (options.hasOwnProperty('compareSelector')) {
                var comparisonElement = $(options.compareSelector);
                if (!($(comparisonElement).length && $(comparisonElement).val().length)) {
                    console.log("Comparison element doesn't exist comparison value %s ", $(comparisonElement).val());
                    // default to valid - rely on server side validation
                    return true;
                }

                // override the value parameter with obtained from the comparison elementL
                value = $(comparisonElement).val();

                console.log("Validating name using specify selector " + $(element).prop('name'));
                console.log("This value is" + value + " looking for previous class " + options.compareSelector);
            }


            var testDate = Date.parseExact(value, 'dd/MM/yyyy');

            if (testDate === null) {
                console.log("Invalid date format on base Eleemnt input");
                return false;
            }

            var comparisonDate = Date.parseExact('01/01/2009', 'dd/MM/yyyy');

            console.log("Compaing against date " + comparisonDate);
            console.log("Comparison check is " + testDate.compareTo(comparisonDate));
            if (testDate.compareTo(comparisonDate) < 0) {
                console.log("dateAfter2008 check result = false");
                return false;
            } else {
                console.log("dateAfter2008 check result = true");
                return true;
            }

        },

        function (options) {
            return getErrorMessage("Only periods of unemployment after 2008 can be counted for LCR credit", options.errorKey);
        });
}



function addChildAgeValidator() {
    $.validator.addMethod("isChildDateOfBirth", function (value, element, options) {
        console.log("Validating child date of birth , value = ", value);
        var ageToCompare = options.age;
        console.log("Age to check", ageToCompare);
        var startDate = Date.parseExact(options.startDate, 'dd/MM/yyyy');
        var dobAsDate = Date.parseExact(value, 'dd/MM/yyyy');
        var atAge = new Date(dobAsDate.add({ years: ageToCompare }));
        console.log("Start date " + startDate);
        console.log("At age " + atAge);

        if (atAge.compareTo(startDate) === -1) {
            console.log("DOB + age is greater than start date");
            return false;
        }
        console.log("Validation successful for DOB age");
        return true;

    }, function (options) {
        return getErrorMessage("dateOfBirth.Input.CHILD.Invalid.HEALTH", options.errorKey);
    });
}


function addFutureBirthDateValidator() {
    $.validator.addMethod("isFutureDateOfBirth", function (value, element, options) {
            var baseElemDate = Date.parseExact(value, 'dd/MM/yyyy');
            if (baseElemDate === null) {
                console.log("Invalid date format on base Element input");
                return false;
            }
            console.log("Using a specific selector passed ", baseElemDate);

            var comparisonDate = new Date();
            if (options && typeof options === 'string') {
                Date.parseExact(options, 'yyyy-MM-dd');
            }

            if (comparisonDate === null) {
                console.log("Invalid date format on base comparison date input");
                return false;
            }

            console.log("Compaing against date " + comparisonDate);
            console.log("Comparison check is " + baseElemDate.compareTo(comparisonDate));
            if (baseElemDate.compareTo(comparisonDate) > 0) {
                console.log("Future date check result = false");
                return false;
            } else {
                console.log("Future date check result = true");
                return true;
            }
        },
        function (options) {
            return getErrorMessage("Birth date can not be a future date.", options.errorKey);
        });
}

function addAdultAgeValidator() {
    $.validator.addMethod("isAdultDateOfBirth", function (value, element, options) {
        console.log("Validating adult date of birth , value = ", value);
        var ageToCompare = 18;
        console.log("Age over to check ", ageToCompare);
        var startDate = new Date();//default today
        if (options){
            if (options.age) {ageToCompare=options.age;}
            if (options.startDate) {startDate = Date.parseExact(options.startDate, 'dd/MM/yyyy');}
        }
        var dobAsDate = Date.parseExact(value, 'dd/MM/yyyy');

        if (dobAsDate) {
            var atAge = new Date(dobAsDate.add({years: ageToCompare}));
            //console.log("Start date " + startDate);
            //console.log("At age " + ageToCompare + " will be in " + atAge);

            if (atAge.compareTo(startDate) === 1) {
                console.log("FAIL! DOB +18 is beyond start date/today !");
                return false;
            }
            console.log("Adult validation successful for DOB age");
            return true;
        }else{//date not extracted (incompleted date?)
            return false;
        }
    }, function (options) {
        return getErrorMessage("dateOfBirth.Input.ADULT.Invalid.HEALTH", options.errorKey);
    });
}




function addMax9AdultsLimitValidator() {
    $.validator.addMethod("max9adults", dobCounter(true), function (options) {
        return getErrorMessage("dateOfBirth.Input.ADULT.Invalid.HEALTH", options.errorKey);
    });
}


function addMax9ChildLimitValidator() {
    $.validator.addMethod("max9childs", dobCounter(false), function (options) {
        return getErrorMessage("dateOfBirth.Input.CHILD.Invalid.HEALTH", options.errorKey);
    });
}

/**
 *
 * @param countAdults true - if you want to count adults, false if you want to count children
 * @returns {adultCounter}
 */
function dobCounter(countAdults) {
    return function adultCounter(value, element, options) {
        var $element = $(element);
        var elId = $element.attr('id');
        var elName = $element.attr('name');
        var $form = $element.closest('form');

        var targetGroupCounter = 0;
        var dependantByAgeLimit = 9;//9 for each by default

        console.log("Validating max " + dependantByAgeLimit + " " + (countAdults ? "adults" : "children") + " for " + elId + ' name= ' + elName);

        var nameArray = elName.split('.');
        var nameToSearch = nameArray[nameArray.length-1];

        if (!nameToSearch) {
            console.error('Max insured count can\'t be calculated for input with name: '+ elName);
            return false;
        }

        $("input[name$=']." + nameToSearch + "']", $form).each(function (i, dateField) {
            var dateValue = $(dateField).val();
            if (dateValue) {
                var parsedDate = dateUtils.getDate(dateValue);
                if (parsedDate) {//invalid date
                    var isAdult = dateUtils.isAdult(parsedDate);
                    if (countAdults && isAdult || !countAdults && !isAdult) {
                        targetGroupCounter++;
                    }
                }
            }
        });//for each found DOB
        return targetGroupCounter <= dependantByAgeLimit;
    };
}


/* relies that two input relies on logic
 FROM date field name contains "start"  and TO datefield contains "end"
 in addition both fields has same "ref" number
 */
function addGreaterThanStartValidator() {
    $.validator.addMethod("greaterThanStart", function (value, element, options) {
        console.log("greaterThanStart validator called from " + $(element).attr('id') + ' name= ' + $(element).attr('name')+" ref="+$(element).attr('ref')+" npk="+$(element).attr('npk'));
        var startName= $(element).attr('name');
        startName = startName.replace("end","start");
        var result = true;

        $("input[name='" + startName + "'][npk="+$(element).attr('npk')+"][ref="+$(element).attr('ref')+"]").each(function (i, requiredField) {

            console.log("--CHECK GREATER THAN Start date :" +startName+" ref ="+$(element).attr('ref')+" npk="+$(element).attr('npk')+" for field:"+  $(requiredField).attr('id'));
            if ($(requiredField).val()) {
                var startDate = Date.parseExact($(requiredField).val(), 'dd/MM/yyyy');
                if (startDate === null) {//invalid date
                    console.log('----- STARTDATE check:' + $(requiredField).attr('id') + ' contains ' + $(requiredField).val() + ' - a invalid date!');
                    result = false;
                }
                else {
                    var endDate = Date.parseExact(value, 'dd/MM/yyyy');
                    var cmp = (endDate.compareTo(startDate));
                    console.log("check if startDate " + startDate + " in compare to endDate "+ endDate+ " ==" +cmp);
                    if (cmp === 1) {
                        console.log("OK>>> StartDate IS before EndDate!");
                        //result= true;//ok - default
                    }
                    else {
                        console.log("-- GREATER THAN Start date FAIL>>> StartDate IS BEHIND EndDate!");
                        result = false;
                    }
                }
            }
        });//for each found field

        return result;

    }, function (options) {
        return getErrorMessage("lcr.employment.dates.less.than", options.errorKey);
    });
}





function addGenericStringValidator() {
    $.validator.addMethod(
        /*
         * The name of the validation method.
         */
        "genericString",
        /*
         * Call to generate the required functions`	.
         */
        generateValidator(),
        /**
         * Function that generates the error message, based on the specific error
         * key. If no value is found for the specified key, the key itself is
         * returned, so that some error message is shown. 
         * 
         * @param options   Array of options consisting of options.errorKey - mandatory field. 
         * 					This is the key for the error message options.optional - optional field.
         * 					This indicates if the field is optional, defaults to true if not specified.
         */
        function (options) {
            return getErrorMessage("generic.string.Invalid", options.errorKey);
        });
}

/*
 * Prepares a validator for a PPSN
 */
function addPpsnValidator() {
    $.validator.addMethod(
        /*
         * The name of the validation method.
         */
        "ppsNumber",

        /*
         * Call to generate the required functions`	.
         */
        generateValidator("pps.number"),

        /**
         * Function that generates the error message, based on the specific error
         * key. If no value is found for the specified key, the key itself is
         * returned, so that some error message is shown. 
         * 
         * @param options   Array of options consisting of options.errorKey - mandatory field. 
         * 					This is the key for the error message options.optional - optional field.
         * 					This indicates if the field is optional, defaults to true if not specified.
         */
        function (options) {
            return getErrorMessage("PPSN.Input.Invalid", options.errorKey);
        });
}

/*
 * Prepares a validator for a mobile number
 */
function addMobileNumberValidator() {
    $.validator.addMethod("mobileNumber", function (value, element, options) {
        return validateField(value, "mobile.number", element);
    }, function (options) {
        return getErrorMessage("mobileNumber.Input.Invalid", options.errorKey);
    });
}

/*
 * Prepares a validator for international mobile number for join-checkout-people page
 */
function addIntlMobileNumberValidator() {
    $.validator.addMethod("intlMobileNumber", function (value, element, options) {
        return validateField(value, "intl.mobile.number", element);
    }, function (options) {
        return getErrorMessage("mobileNumber.Input.Invalid", options.errorKey);
    });
}

function addIEAndUKMobileNumberValidator() {
    $.validator.addMethod("ieAndUkMobileNumber", function (value, element, options) {
        var mobileCode = $(element).parent().siblings().find("select").val();
        var mobileNumber = value;
        var fullNumber = combinePhoneCodeNumber(mobileCode, mobileNumber);
        return this.optional(element) || matchesIEAndUKFormat(fullNumber);
    }, function (options) {
        return getErrorMessage("mobileNumber.Input.Invalid", options.errorKey);
    });
}
/*
 * Prepares a validator for a contact number
 */
function addContactNumberValidator() {
    $.validator.addMethod("contactNumber", function (value, element, options) {
        return validateField(value, "contact.number", element);
    }, function (options) {
        return getErrorMessage("contactNumber.Input.Invalid", options.errorKey);
    });
}

/*
 * Prepares a validator for an IBAN. This can validate general IBANs (Irish and foreign) or just Irish, by specifying
 * true for the irelandOnly switch in the options. This first validates the value using the inbuilt IBAN validator (which
 * does a "check digit" validation), and then against the custom VHI regex. Both must return true for the validation to pass.  
   */
function addIbanValidator() {
    $.validator.addMethod("iban", function (value, element, options) {
        if (shouldValidateField(element)) {
            var ibanCheckDigitResult = $oldIban.call(this, value, element, options);
            var customRegexValid = options.irelandOnly ? validateField(value, "iban.ireland.only", element) : validateField(value, "iban.general", element);
            var overallResult = ibanCheckDigitResult && customRegexValid;
            return overallResult;
        }

        // No error
        return true;
    }, function (options) {
        if (options.irelandOnly) {
            return getErrorMessage("IBAN.Input.Invalid.Ireland.Only", options.errorKey);
        }

        return getErrorMessage("IBAN.Input.Invalid.General", options.errorKey);
    });
}

/*
 * Prepares a validator for a credit card expiry date, which is made up of
 * two fields, which need to be validated together
 */
function addCardExpiryDateValidator() {
    $.validator.addMethod("cardExpiryDate", function (value, element, options) {
        if (shouldValidateField(element)) {
            var expiryMonth = $('#' + options.monthId).val();
            var expiryYear = $('#' + options.yearId).val();
            var firstOfThisMonth = getFirstDayOfMonth();

            // Minus one as JS dates are zero-based, whereas the select is
            // 1-based
            var expiry = new Date(expiryYear, expiryMonth - 1, 1);
            var valid = expiry >= firstOfThisMonth;

            return valid;
        }

        // No error
        return true;
    }, function (options) {
        return getErrorMessage("expiry.Year.Past", options.errorKey);
    });

    function getFirstDayOfMonth() {
        var nowDate = new Date();
        var firstOfThisMonth = new Date(nowDate.getFullYear(), nowDate.getMonth(), 1);
        return firstOfThisMonth;
    }
}

/*
 * Prepares a validator for a BIC
 */
function addBicValidator() {
    $.validator.addMethod("bic", function (value, element, options) {
        return validateField(value, "bic", element);
    }, function (options) {
        return getErrorMessage("BIC.Input.Invalid", options.errorKey);
    });
}

/*
 * Prepares a validator for a CVV number on a credit card
 */
function addCvvValidator() {
    $.validator.addMethod("cvv", function (value, element, options) {
        return validateField(value, "cvv", element);
    }, function (options) {
        return getErrorMessage("cvvNumber.Input.Invalid", options.errorKey);
    });
}

/*
 * Prepares a validator for a credit card number.
 * 
 * Firstly checks if it is a valid CC number, using in-built Luhn check. It also applies our own custom credit card 
 * regex (which further limits it to Visa and Mastercard). Only if both of these checks pass do we allow the value.
 */
function addCreditCardNumberValidator() {
    $.validator.addMethod("creditCardNumber", function (value, element, options) {
        if (shouldValidateField(element)) {
            var luhnResult = $oldCreditCard.call(this, value, element, options);
            var customValidateResult = validateField(value, "card.number", element);
            var overallResult = luhnResult && customValidateResult;

            return overallResult;
        }

        // No error
        return true;
    }, function (options) {
        return getErrorMessage("cardNumber.Input.Invalid", options.errorKey);
    });
}

/*
 * Prepares a validator for an email address
 */
function addEmailAddressValidator() {
    $.validator.addMethod("emailAddress", function (value, element, options) {
        return validateField(value, "email.address", element);
    }, function (options) {
        return getErrorMessage("emailAddress.Input.Invalid", options.errorKey);
    });
}

/*
 * Prepares a validator for a VHI policy number
 */
function addPolicyNumberValidator() {
    $.validator.addMethod("policyNumber", function (value, element, options) {
        var optional = options.optional;

        if (optional || this.optional(element)) {
            return true;
        }

        console.log("Validating mandatory policy number ", value);
        return validateField(value, "policy.number", element);
    }, function (options) {
        $("#" + this.currentElements.attr('id') + '-error').remove();
        return getErrorMessage("policyNumber.Input.Empty", options.errorKey);
    });
}

/*
 * Prepares a validator for a date in for the format dd/MM/yyyy
 */
function addDateFormatValidator() {
    $.validator.addMethod("dateFormat", function (value, element, options) {
        console.log("dateFormat testing %s", value);

        var optional = options.optional;

        if (optional) {
            console.log("Validating optional date field ", value);
            return this.optional(element) || validateDateField(value, "date.format", element);
        }

        console.log("Validating mandatory date field ", value);

        var result = validateDateField(value, "date.format", element);

        console.log("date format valid = %s", result);

        return result;
    }, function (options) {
        return getErrorMessage("dateOfBirth.Input.Missing", options.errorKey);
    });
}

/*
 * Validates that a date is in the valid dd/MM/yyyy format. Usually this is for date of birth, but could be used 
 * for any manually inputted field that is a date.
 */
function validateDateField(value, regexKey, element) {
    var isValid = false;

    //do validation only if minlength is set
    if (shouldValidateField(element) && futureRules.elemHasNoFutureRule(element)) {

        // The field is visible so we should validate it, now do so.
        if (validateField(value, regexKey, element)) {
            var dateParts = value.split("/");
            var day = parseInt(dateParts[0], 10);
            var month = parseInt(dateParts[1], 10);
            var year = parseInt(dateParts[2], 10);
            var xdata = new Date(year, month - 1, day, 12, 0, 0, 0);

            if ((xdata.getUTCFullYear() === year) && (xdata.getUTCMonth() === month - 1) && (xdata.getUTCDate() === day)) {
                isValid = true;
            }
        }
    } else {
        // The field is not visible so its always valid
        isValid = true;
    }
    return isValid;
}

/*
 * Replaces the in-built JQuery "required" validator to allow specification
 * of an error message key as part of the rule, which removes the need for a
 * separate "messages" section. It simply delegates onto the underlying
 * JQuery "required" function to do the actual validation work.
 */
function addRequiredValidator() {
    $.validator.addMethod("required", function (value, element, options) {
        if (shouldValidateField(element)) {
            var result = $oldRequired.call(this, value, element, options);
            return result;
        }

        // No error
        return true;
    }, function (options) {
        return getErrorMessage("required.field", options.errorKey);
    });
}

/*
 * Prepares a validator for a ZIP code
 */
function addZipCodeValidator() {
    $.validator.addMethod("zipCode", function (value, element, options) {
        // Remove spaces dashes before validation, as per server side. 
        var strippedZipCode = value.replace(/[\s-]/g, '');
        console.log('Testing zip code: ', strippedZipCode);

        return validateField(strippedZipCode, "zip.code", element);
    }, function (options) {
        return getErrorMessage("zipCode.Input.Invalid", options.errorKey);
    });
}

/*
 * Prepares a validator for a monetary field
 */
function addMonetaryAmountValidator() {
    $.validator.addMethod("moneyAmount", function (value, element, options) {
        var optional = options.optional;

        if (optional) {
            console.log("Validating optional money amount, value = ", value);
            return this.optional(element) || validateField(value, "money.amount", element);
        }

        console.log("Validating mandatory money amount, value = ", value);
        return validateField(value, "money.amount", element);
    }, function (options) {
        return getErrorMessage("monetary.Input.Invalid", options.errorKey);
    });
}

/*
 * Prepares a range validator for a field
 */
function addRangeValidator() {
    $.validator.addMethod("range", function (value, element, options) {
        if (shouldValidateField(element)) {
            return $oldRange.call(this, value, element, options.theRange);
        }
        // No error
        return true;
    }, function (options) {
        return getErrorMessage("range.Input.Invalid", options.errorKey);
    });
}




/*
 * Prepares a FirstName and LastName validator for a field
 * (extracted from WAM services signup) https://web-wam-05.vhihealthcare.net/access/js/common/customValidationRules.js [isName]
 *
 *
 * Validate name: has only letters and spaces
 * usage - isName: true
 * changes defect #33072 - need to support CASE INSENSIVE character names with spaces, dashes and apostrophes
 * changes defect #33779 - need support accent characters: fadas and umlauts    ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÑÒÓÔÕÖØÙÚÛÜßàáâãäåæçèéêëìíîïñòóôõöøùúûüÿµ
 * roolback WAM PHASE2 - remove accent character support (18.10.2016)
 *
 * Requirement Change 2017-12-06 by David Conway , two spaces in a row is acceptable, "O'Conor" variant "O'  Conor" is accepted now too.
 * O’  Mahony
 * Mc  Dermott

 * no digits or other characters allowed
 * NOT WORKING with UNICODE OTHER symbols except fadas and umlauts above ( U+0080–U+00FF ,  U+0100–U+017F ,  U+0180–U+024F , U+0400–U+04FF )
 * ! Beware ! - passed names must be compatible with ActiveDirectory LDAP, GIOS and KANA
 *
 * tested patterns:
 *   STEVE SMITH (pass)
 *   Stev3 Smith (fail - numbers)
 *   STeve Smith (pass)
 *   Steve+SMith (fail - other spec-char than space/'/- )
 *   d'Are to Beaware (pass)
 *   Jo Blow (passed)
 *   D C
 *   Hyoung Kyoung Wu (passed)
 *   Mike O'Neal (passed)
 *   Steve Johnson-Smith (passed)
 *   Jozef-Schmozev Hiemdel (passed)
 *   O Henry Smith (passed)
 *   Mathais d'Arras (passed)
 *   Martin Luther King Jr (passed)
 *   Downtown-James Brown (passed)
 *   Darren McCarty (passed)
 *   George De FunkMaster (passed)
 *   Kurtis B-Ball Basketball (passed)
 *   Ahmad el Jeffe (passed)
 *   Jamal-  (fail)
 *   Difu--Hund (fail)
 *   Ärnstain Höffer (PASS NOW - extended ASCII chars), NOT PASS- removed
 */
function addPersonNamesValidator() {
    $.validator.addMethod("personNames", function (value, element, options) {
        var regex = new RegExp('^([A-Za-z]{1,30}[ ]{0,2}|[A-Za-z]{1,30}[- \']{1}[ ]{0,2}[A-Za-z]{1,30}){1,5}$');
        var result = regex.test(value);
        return result;
    },
        function (options) {
            return "Incorrect characters used, please enter using A-Z or a-z only.";
        });
}

/*
 * Validates the specified value against the specified regular expression
 * @param value The value to test 
 * @param regex The regexKey to validate against
 * @param element The element containing the value
 */
function validateField(value, regexKey, element) {
    var validationRegexes = validation.validationRegexes;
    var regex = new RegExp(validationRegexes[regexKey]);
    console.log("Validating against %s on element '%s'", regex, element.id);

    if (shouldValidateField(element)) {
        console.log("Validating against %s", regex);
        return regex.test(value);
    }

    return true;
}

/*
 * Check if the specified field should be validated.
 * 
 * @return true if the field is visible, false otherwise. If the type is "hidden", we check the parent node (as a
 * hidden field will never be visible). An example of this is the "type-ahead county" field, where the validated 
 * field is actually a hidden field. 
 */
function shouldValidateField(element) {
    var result = false;
    if (element.type === "hidden") {
        result = isVisible(element.parentNode);
    } else {
        result = isVisible(element) && futureRules.elemHasNoFutureRule(element);
    }

    return result;

}

/*
 * Function to test if the specified element is visible
 * 
 * @param The element to test ("regular" JS object, not JQuery) 
 */
function isVisible(element) {
    return $(element).is(':visible');
}


/**
 * Generate validation function.
 * <p>
 * This a builder for the function that performs the actual validation.
 * </p> 
 * 
 * @param regexKeyOverride provides the ability to override the regex key defined in options.
 * 
 */
function generateValidator(regexKeyOverride) {

    /**
     * The validation function implementation.
     * 
     * @param value The value of the element 
     * @param element The element being validated 
     * @param options Array of options consisting of:
     * <ul>	  
     * <li>options.errorKey - mandatory field. This is the key for the error message.</li>
     * <li>options.regexKey - optional field. This indicates the validation should use a custom regex key, falling back to "generic.string" as the key if this is omitted.</li>
     * </ul>
     */
    return function (value, element, options) {
        // Trim any spaces from the end of the string.
        value = value.trim();
        var regexKey = (options.regexKey) ? options.regexKey : "generic.string";
        if (regexKeyOverride) {
            regexKey = regexKeyOverride;
        }
        var result = null;

        result = this.optional(element) || validateField(value, regexKey, element);

        return result;
    };
}

function combinePhoneCodeNumber(phoneCode, phoneNumber) {
    var mobileNumberWithCountryCode = null;
    if ((phoneCode !== null && phoneNumber !== null) && (!isNaN(phoneNumber))) {
        mobileNumberWithCountryCode = phoneCode.concat("-").concat(phoneNumber);
    }
    return mobileNumberWithCountryCode;
}

function matchesIEAndUKFormat(mobileNumber) {
    var splittedNumber = mobileNumber.split("-", 2);
    var countryCode = splittedNumber[0];
    var strippedMobileNumber = splittedNumber[1];
    var isValid = true;
    if (countryCode === "+353") {
        var ieRegex = new RegExp(/^(08|8)[0-9]{8}$/);
        isValid = ieRegex.test(strippedMobileNumber);
    }
    if (countryCode === "+44") {
        var ukRegex = new RegExp(/^(07|7)[0-9]{9}$/);
        isValid = ukRegex.test(strippedMobileNumber);
    }
    return isValid;
}

/**
 * Page init function that is called when the module is loaded
 */
function pageInitialisation() {
    initValidations();
}

pageInitialisation();

module.exports.getErrorMessage = getErrorMessage;
module.exports.shouldValidateField = function (element) {
    return shouldValidateField(element);
};

/***/ }),

/***/ "s5DP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("7t+N");
/**
 * futureRules is extension for jquery validator functionality
 *
 * Future Rules is a concept introduced to facilitate business requirements to trigger certain UX queues as user types
 * Jquery Validation doesn't support event based rules, thus additional layer is created
 *
 * Future Rules converts elements future rule to a jquery rule once conditions have been met.
 * This is achieved by replacing attribute data-future-rule-* with data-rule-* once the conditions have been met.
 *
 * Currently supported future rule:
 *  data-future-rule-minlength
 */

/**
 * Function to be invoked after all fields have been populated with their previous values
 * This function evaluates if future rules should be applied on any of the elements
 * @param form
 */
function renderingDone(form) {
    $('input[data-future-rule-minlength]', form).each(function(index, el){
        evalMinLength(el);
    });
}

/*
 * Find all future rules in provided form. Ignores fields configured to be ignored by validator
 * For now only data-future-rule-minlength is supported
 */
function getFutureRules(form) {
    var ignore = [];

    var validator = $(form).data("validator");
    if (validator) {
        ignore = $(form).data("validator").settings.ignore;
    }

    return $('input[data-future-rule-minlength]', form).not(ignore);
}

/*
 * Return true only if there are no future rules on the form
 */
function hasNoFutureRules(form) {
    return getFutureRules(form).length === 0;
}

function elemHasNoFutureRule(element) {
    return (typeof $(element).attr('data-future-rule-minlength') === "undefined");
}

/*
 * Applies all future rules on the form
 */
function applyAllFutureRules(form) {
    getFutureRules($(form)).each(function(i, el) {
        evalMinLength(el, true);
    });
}

/*
 * If element has attribute data-future-rule-minlength and its value satisfies the condition
 * attribute will be converted to jquery data validation rule and future rule removed
 */
function evalMinLength(el, force) {
    var element = $(el);
    var minLength = element.attr('data-future-rule-minlength');
    if (minLength && (force || (element.val().length >= minLength))) {
        element.removeAttr('data-future-rule-minlength');
        element.attr('data-rule-minlength', minLength);
        console.log('Added minlength=' + minLength + ' rule to ' + element.attr('name'));
    }
}

//public
module.exports.renderingDone = renderingDone;
module.exports.hasNoFutureRules = hasNoFutureRules;
module.exports.elemHasNoFutureRule = elemHasNoFutureRule;
module.exports.applyAllFutureRules = applyAllFutureRules;
//protected
module.exports.evalMinLength = evalMinLength;

/***/ }),

/***/ "xGcg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__("7t+N");
var intlPageSetup = __webpack_require__("+No7");
var disablingLayer = __webpack_require__("OBNk");
var form2js = __webpack_require__("/PV3");
var validation = __webpack_require__("kMMZ");
var createValidator = __webpack_require__("kMMZ").createValidator;
var EmployeeGroupSelect = __webpack_require__("OEM9");
var StartDatePicker = __webpack_require__("P32B");
var intlStateService = __webpack_require__("NI/0");
var transactionStageService = __webpack_require__("KVib");
var urls = __webpack_require__("g+w9");
var breadCrumb = __webpack_require__("Dh8f");
var renewalSuspended = __webpack_require__("WMth");
var inputHelper = __webpack_require__("LaRm");
var thisPageAnalytics = __webpack_require__("eURo");

__webpack_require__("r1X9");

var pageValidator;
var productType = 'GLOBAL';
var formId = 'detailsStartForm';

function init() {
    var model;
    var transactionStage = transactionStageService.getTransactionStage();
    var startDatePicker;

    return $.when(intlStateService.getTransactionState(), intlPageSetup.init())
        .then(function (transactionStateModel) {
                model = transactionStateModel;

                pageValidator = createPolicyPageValidator();

                startDatePicker = new StartDatePicker({
                    id: 'policyStartDate',
                    mountOn: 'policyStartDateRow',
                    mountImmediateley: false,
                    inputName: 'policyDate',
                    i18nContext: 'details.start.',
                    supportTextVisible: true,
                    supportTexti18nPostfix: renewalSuspended.getSupportTexti18nPostfix,
                    supportTextStyleClass: renewalSuspended.getSupportTextStyleClass
                });

                var employeeGroupsPromise = new EmployeeGroupSelect({
                    id: 'employeeGroup',
                    mountOn: 'employeeGroupRow',
                    onChange: onEmployeeGroupChange,
                    renderSingleGroup: false,
                    readOnly: false,
                    inputName: 'employeeGroup',
                    i18nContext: 'details.start.'
                });
                return employeeGroupsPromise;
        })
        .then(function(employeeGroupComponent) {
            var availableGroupIds = employeeGroupComponent.getAvailableGroups();
            var employeeGroupId = model.employeeGroup;

            if (availableGroupIds.length === 1) {
                employeeGroupId = availableGroupIds[0];
            }
            if (employeeGroupId) {
                employeeGroupComponent.setValue(employeeGroupId);
                setEmployeeGroup(employeeGroupId);
            }
        })
        .then(function () {
            $('.journey-content').localize();
            disablingLayer.hideDisablingLayer();
            form2js.js2form(formId, model);
            validateForm();
            initBreadCrumb();
            thisPageAnalytics.addAnalyticsHandlers();
        });

    function initBreadCrumb() {
        breadCrumb.init({
            sessionTransactionStage: transactionStage
        });
    }

    function onEmployeeGroupChange(employeeGroupId) {
        $('#policyStartDate').val('');
        $('#policyStartDate').prop('disabled', true);
        setEmployeeGroup(employeeGroupId);
    }

    function setEmployeeGroup(employeeGroupId) {
        model.employeeGroup = employeeGroupId;
        if (employeeGroupId) {
            return startDatePicker.render(employeeGroupId, productType);
        } else {
            $('.policy-start-date-support-text').hide();
            startDatePicker.setValue('');
            return $.Deferred().resolve();
        }
    }

    function createPolicyPageValidator() {
        return createValidator($("#" + formId), {
            submitHandler: next,
            onkeyupCallback: validateForm,
            onfocusoutCallback: onFocusOutValidateForm,
        });
    }

    function validateForm() {
        $('#next').toggleClass("primary-button--inactive", !(validation.isValid('#' + formId)));
    }

    function onFocusOutValidateForm() {
        inputHelper.trimElementValue($('#firstName'));
        inputHelper.trimElementValue($('#lastName'));

        validateForm();
    }

    function next(form) {
        var formInput = form2js.form2js(formId);
        var mergedModel = $.extend(true, {}, model, formInput);
        intlStateService.postTransactionState(mergedModel)
            .then(function() {
                transactionStageService.setTransactionStage('POLICY');
                urls.navigateToUrl('/intgroups/join-details-policy?transaction-id=' + model.transactionId);
            })
            .fail(validation.renderServerErrors('#' + formId));
    }
}

module.exports.init = init;


/***/ }),

/***/ "yq58":
/***/ (function(module, exports) {

var FormEvents = {
    FORM_START: 'form_start',
    QUOTE_COMPLETE: 'quote_complete',
    FORM_STEP_BACK: 'form_step_back',
    EMAIL_QUOTE: 'email_quote',
    FORM_STEP_COMPLETE: 'form_step_complete',
    PURCHASE: 'purchase',
    FULL_QUOTE_COMPLETE: 'full_quote_complete',
    NUMBER_PLANS_RETURNED: 'number_plans_returned',
    SNAP_AND_SEND_SUBMIT: 'snap_send_submit',
};

var FormStepTypes = {
    START: 'start',
    COMPLETE: 'complete',
    GET_QUOTE: 'get_quote',
    QUOTE_REVIEW: 'quote_review',
    GET_FULL_QUOTE: 'get_full_quote',
    FULL_QUOTE_REVIEW: 'full_quote_review',
    PREFERENCES: 'preferences',
    PEOPLE: 'people',
    DETAILS: 'details',
    CHECKOUT: 'checkout',
    CLAIM_SEND: 'claim_send',
    ADD_ONS: 'add_ons',
    SUBMIT: 'submit'
};

module.exports = {
    FormEvents: FormEvents,
    FormStepTypes: FormStepTypes,
};

/***/ }),

/***/ "z0NW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Moved from APM.js by c_samarska_d on 12/10/2018.
 *
 */

var $ = __webpack_require__("7t+N");

function initPopOver(customPopoverClass) {
    $('[data-toggle=popover]').popover({
        html : true,
        placement: 'auto bottom',
        container: '.journey-container',
        viewport: { selector: 'body', "padding": 5 },
        content: function() {
            var content = $(this).attr("data-popover-content");
            return $('#'+content).html();
        }
    }).data('bs.popover').tip().addClass(customPopoverClass);

    $('.journey-container').on('click','.popover__close-button', function(event) {
        var triggerId =$(event.target).attr('data-popover-trigger');
        $('#'+triggerId).popover('hide');
    });
}

/**
 * When the user drags the carousel, hide the popover if it is displayed
 * @param el - The element that is clicked that needs the focus to be removed after the mouse touchmove has finished
 */
function initClosePopOverOnCarouselTouchmove(el) {
    $('.owl-carousel').on({
        'touchmove': function(e) {
            if($('.popover').is(":visible")) {
                $('.popover').popover('hide');
            }
        }
    }).on({'touchend': function(e){
        $(el).blur();
    }});
}

module.exports.initPopOver = initPopOver;
module.exports.initClosePopOverOnCarouselTouchmove = initClosePopOverOnCarouselTouchmove;


/***/ })

},["xGcg"]);


// WEBPACK FOOTER //
// /join-details-start.js